// ═══════════════════════════════════════════════════════════════
// FIELD VALIDATION MARKING
// ═══════════════════════════════════════════════════════════════
// Operator request 2026-08-23: "can we use our red to outline the 'wrong' sections that need
// review before a customer adds to cart so it's very clear what the issue is".
//
// ⛔ WHAT IT REPLACED. Twelve add-to-cart checks each scrolled to the offending field and
// focused it — and marked NOTHING. On a long form a caret in a box is easy to miss, and the
// acknowledgement check used a browser alert(), which names the problem but cannot show you
// where it is. So the page said "something is wrong" and left you to find it.
//
// ⚠ Every one of the twelve had its own copy of the scroll-and-focus lines, which is how one
// of them drifted to `- 250` where the others use `- 300`. One helper now, called from all
// twelve, so the next change happens once.
//
// ⭐ Clears itself the moment the field is touched. A red box that stays red after you fix it
// is worse than no red box — it trains people to ignore the colour.
(function () {
  if (document.getElementById('sgp-validation-styles')) return;
  var st = document.createElement('style');
  st.id = 'sgp-validation-styles';
  st.textContent = [
    // #D7263D is the brand crimson. Outline + halo rather than a background tint: these fields
    // sit on several different panel colours, and a tint that reads on white disappears on teal.
    // ⚠ ONE line, not a line plus a ring. A 3px solid-ish halo beside the element's own border
    // read as a second edge — the "double line" the operator flagged. The border recolours in
    // place and the glow is wide and faint enough to be a glow rather than an outline.
    '.sgp-invalid{border-color:#D7263D !important;box-shadow:0 0 0 4px rgba(215,38,61,.09) !important;}',
    '.sgp-invalid:focus,.sgp-invalid:focus-within{border-color:#D7263D !important;box-shadow:0 0 0 4px rgba(215,38,61,.16) !important;}',
    // No border of its own to recolour — message only. Used for the acknowledgement row, where
    // a rect around the whole thing swallowed the text.
    '.sgp-invalid-quiet{}',
    // "Make the little box turn red."
    // ⛔ THE BOX IS A PSEUDO-ELEMENT. From the live theme's custom.css:
    //      .checkbox-field-wrapper label:after { border: 3px solid #1F4F67; ... }
    // The real <input> is clipped to 1px and hidden, so it is not the square, and a `*`
    // descendant selector can NEVER match ::after — which is why two earlier attempts did
    // nothing visible. Ringing the wrapper failed differently: the wrapper is wider than the
    // box and starts left of it, so the outline sat off-centre over the "I" of "I confirm".
    // ⚠ Read from the live stylesheet rather than guessed — that CSS is not in the repo mirror,
    // and three attempts had already been spent inferring it.
    '.add_ons_acknowledge_head.sgp-invalid-quiet .checkbox-field-wrapper label:after,',
    '.add_ons_acknowledge_head.sgp-invalid .checkbox-field-wrapper label:after{',
    'border-color:#D7263D !important;background-color:rgba(215,38,61,.08) !important;}',
    // The tick shares the box's colour, so it has to move with it or a ticked-then-untouched
    // state would show a navy tick inside a red box.
    '.add_ons_acknowledge_head.sgp-invalid-quiet .checkbox-field-wrapper svg,',
    '.add_ons_acknowledge_head.sgp-invalid .checkbox-field-wrapper svg{stroke:#D7263D !important;}',
    '.sgp-invalid-msg{display:block;color:#D7263D;font-family:"Hind-Medium",Arial,sans-serif;',
    'font-size:13.5px;font-weight:600;line-height:1.4;margin-top:7px;}',
    '@media (prefers-reduced-motion:reduce){html{scroll-behavior:auto;}}',

    // ═══ Picker states ═══════════════════════════════════════════════════════════════════
    // Operator: the item-type tile and size chips are "not clear enough", the selected and
    // unselected states "too close of a difference".
    //
    // ⛔ THE REAL CAUSE WAS NOT CONTRAST. The live theme carries:
    //      .select_item_type__item_active .select_item_type__item_img{
    //         border-color:#1f4f67; transition:2000s ease-in-out; }
    //    Two thousand seconds. The selection border fades in over ~33 MINUTES, so clicking a
    //    tile produced no visible feedback whatsoever. Everything below is secondary to that.
    //
    // ⚠ These override `assets/custom.css`, which is NOT in the repo mirror — so this cannot be
    //   fixed at source without hand-editing the theme outside version control. Kept here so
    //   the change is reviewable and travels with the file the operator already pastes.
    // ⚠ !important throughout, because the theme's own selectors run four classes deep.

    // 1 · the transition that hid the whole interaction
    '.select_item_type__item.select_item_type__item_active .select_item_type__item_img{transition:border-color .15s ease,box-shadow .15s ease !important;}',

    // 2 · selected reads as SELECTED — a 2px teal edge and a teal-tinted ground against the
    //     grey unselected tiles. A 1px border going from pale grey to navy was the entire
    //     previous signal.
    // ⚠ NOT white. White is not in the brand palette and does not appear anywhere else on these
    //   pages, so a white ground read as a hole rather than as a state. Every tint here is the
    //   brand teal #1086A2 at low alpha — same hue as the border, so the tile reads as one
    //   object changing state instead of two colours meeting.
    // ⛔ NO RING. A 3px halo outside a 2px border renders as TWO concentric edges — the same
    //   "double line" the operator rejected on the red validation outline. The tile already
    //   carries a pale inner band (the container's padding, now tinted) between the image and
    //   the border, so a third ring outside it made three concentric bands on one tile.
    //   ⇒ box-shadow:none, explicitly, because the theme sets one of its own.
    '.select_item_type__item.select_item_type__item_active .select_item_type__item_img{',
    'border:2px solid #1086A2 !important;box-shadow:none !important;background:rgba(16,134,162,.12) !important;}',
    '.select_photo_item.select_photo_item_active .select_photo_item__size{',
    'border:2px solid #1086A2 !important;box-shadow:none !important;background:rgba(16,134,162,.12) !important;font-weight:700;}',

    // 3 · unselected should look CLICKABLE. Nothing moved on hover before, so a tile read as a
    //     picture rather than a control.
    // ⚠ Hover is the SAME hue at roughly half the strength, so hover reads as "on the way to
    //   selected" rather than as a third, unrelated state. The 2px border and the ring are what
    //   separate the two — not a different colour.
    '.select_item_type__item:not(.select_item_type__item_active) .select_item_type__item_img,',
    '.select_photo_item:not(.select_photo_item_active):not(.sold_out_item) .select_photo_item__size{transition:border-color .15s ease,background .15s ease;}',
    '.select_item_type__item:not(.select_item_type__item_active):hover .select_item_type__item_img,',
    '.select_photo_item:not(.select_photo_item_active):not(.sold_out_item):hover .select_photo_item__size{',
    'border-color:#1086A2 !important;background:rgba(16,134,162,.07) !important;}',

    // 4 · disabled should be unmistakably out of play. `opacity:.5` alone still reads as "dim
    //     but usable"; greyscale plus a not-allowed cursor says the step is not available yet.
    //     ⚠ pointer-events:none is on the theme's rule, so the cursor must go on the CONTAINER.
    '.itg_disable_items{opacity:.45 !important;filter:grayscale(100%);cursor:not-allowed;}'
  ].join('');
  (document.head || document.documentElement).appendChild(st);
})();

/** Remove the invalid state from one element and drop its message. */
function sgpClearInvalid(el) {
  if (!el) return;
  el.classList.remove('sgp-invalid', 'sgp-invalid-quiet');
  var msg = el.parentNode && el.parentNode.querySelector(':scope > .sgp-invalid-msg');
  if (msg) msg.remove();
}

/** Clear every field currently marked — called at the top of a fresh submit attempt, so a
 *  second click never leaves stale red on a field the customer has since filled in. */
function sgpClearAllInvalid() {
  document.querySelectorAll('.sgp-invalid, .sgp-invalid-quiet').forEach(sgpClearInvalid);
}

/**
 * The element that should actually carry the red.
 *
 * ⛔ WHY THIS EXISTS. Marking the field itself produced a DOUBLE LINE: the textarea sits inside
 * `.add_on__head_fields`, which draws its own border, so a red border on the input rendered as
 * a second rounded rect nested inside a grey one. Operator: "don't like that double line thing
 * going on with the red and blue."
 *
 * ⇒ Walk up to two levels for an ancestor that already draws a border and colour THAT instead,
 * so there is exactly one line and it lands where the eye already reads an edge. Falls back to
 * the field when nothing above it has a border.
 */
function sgpVisualTarget(el) {
  var node = el;
  for (var i = 0; i < 3 && node && node !== document.body; i++) {
    var w = parseFloat(getComputedStyle(node).borderTopWidth) || 0;
    if (w > 0) return node;
    node = node.parentElement;
  }
  return el;
}

/**
 * Record a problem's mark WITHOUT scrolling — scrolling is the caller's job once every
 * problem is known, or the page would jump per failure.
 */
function sgpMarkInvalid(selector, message) {
  var el = document.querySelector(selector);
  if (!el) return null;
  var target = sgpVisualTarget(el);

  // ⚠ A target with no border of its own gets NO outline — only the message. That is the
  // acknowledgement row: a red rect around it swallowed the text and read as a heavy box.
  // Its little checkbox is ringed by a CSS rule instead, which is all the operator asked for.
  var hasBorder = (parseFloat(getComputedStyle(target).borderTopWidth) || 0) > 0;
  target.classList.add(hasBorder ? 'sgp-invalid' : 'sgp-invalid-quiet');

  if (!(target.parentNode && target.parentNode.querySelector(':scope > .sgp-invalid-msg'))) {
    var m = document.createElement('span');
    m.className = 'sgp-invalid-msg';
    m.setAttribute('role', 'alert');
    m.textContent = message || 'Please complete this before adding to cart.';
    target.insertAdjacentElement('afterend', m);
  }
  // Announce it to assistive tech, which a colour change alone does not.
  if (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)) el.setAttribute('aria-invalid', 'true');

  // ⚠ ONE-TIME listeners. Re-marking would otherwise stack a listener per failed attempt, and
  // every one of them would fire on the next keystroke.
  ['input', 'change', 'click'].forEach(function (ev) {
    target.addEventListener(ev, function handler() {
      sgpClearInvalid(target);
      el.removeAttribute('aria-invalid');
      ['input', 'change', 'click'].forEach(function (e2) { target.removeEventListener(e2, handler); });
    }, { once: true });
  });
  return target;
}

/**
 * Mark EVERY problem found in one pass, then scroll to whichever sits highest on the page.
 *
 * ⛔ Replaces twelve independent early returns. Each used to mark one field and stop, so a
 * customer with three things missing was told about them one at a time, re-submitting between
 * each — operator: "I feel like it should highlight all the issues so the user just does it
 * once."
 *
 * ⚠ Scrolls to the TOPMOST problem by document position, not to the first one CHECKED. The
 * checks run in their own order, which has nothing to do with where the fields sit on screen,
 * so scrolling to the first check could jump PAST problems above it.
 *
 * @param {Array<[string, number, string?]>} problems  [selector, scrollOffset, message?]
 * @returns {false} always, so callers can `return sgpReportProblems(...)`
 */
function sgpReportProblems(problems) {
  var marked = [];
  problems.forEach(function (p) {
    var t = sgpMarkInvalid(p[0], p[2]);
    if (t) marked.push({ el: t, offset: p[1] });
  });
  if (!marked.length) return false;

  marked.sort(function (a, b) {
    return a.el.getBoundingClientRect().top - b.el.getBoundingClientRect().top;
  });
  var first = marked[0];
  window.scrollTo({
    top: first.el.getBoundingClientRect().top + window.pageYOffset - (first.offset || 300),
    behavior: 'smooth'
  });
  var field = first.el.querySelector('input, textarea, select') || first.el;
  if (field.focus) { try { field.focus({ preventScroll: true }); } catch (e) {} }
  return false;
}

// ═══════════════════════════════════════════════════════════════
// PHOTO ID VALUE  —  read it from an attribute, never from the text
// ═══════════════════════════════════════════════════════════════
//
// ⛔ `.photo_id_button` is BOTH the on-screen label and, historically, the place the
// submitted `Photo ID` cart property was read back from, via `.text()`. Chrome's page
// translator rewrites text nodes IN PLACE, so a customer viewing the page translated
// submitted the TRANSLATED label as their Photo ID. Three orders reached production
// that way before anyone noticed:
//
//     #5456 (NYCC 2026)      PHOTOREQUEST -> 照片请求
//     #2148 (NYCC 2025)      PHOTOREQUEST -> RICHIESTA FOTOGRAFICA
//     #1536 (Supercon 2025)  PHOTOREQUEST -> RICHIESTA FOTOGRAFICA
//
// Every OTHER property on those orders survived, because the rest are read with
// .attr()/.val() — a translator rewrites text nodes, not attributes. The failure is
// silent end to end: the order looks normal, and it is the portal that quietly stops
// recognising the row (the print count mis-buckets it, the library preview never
// fires). On #5456 that cost a customer photo.
//
// So: keep the canonical value in a data attribute and read THAT. The visible text
// stays exactly as before and remains free to be translated — that is display, and
// display is allowed to change. Only the attribute is data.
//
// The portal carries a matching safety net for orders already placed —
// label-tool/src/utils/photoId.ts.

function setPhotoIdValue($btn, value) {
  $btn.text(value).attr('data-photo-id', value);
}

function getPhotoIdValue($btn) {
  var v = $btn.attr('data-photo-id');
  // Fall back to the text for a page that was already open when this shipped.
  return (typeof v === 'string') ? v : $btn.text();
}

// ═══════════════════════════════════════════════════════════════
// SIGNET PHOTO CROP MODULE  —  mobile-first, touch-optimised
// ═══════════════════════════════════════════════════════════════

(function () {
  'use strict';

  var cropState        = { x: 0, y: 0, w: 0, h: 0 };
  var dragState        = null;
  var pinchState       = null;
  var panState         = null;
  var touchPanState    = null;
  var panX             = 0;
  var panY             = 0;
  var zoomTarget       = 1;
  var zoomAnimId       = null;
  var imgNatW          = 0;
  var imgNatH          = 0;
  var imgDispW         = 0;
  var imgDispH         = 0;
  var baseImgDispW     = 0;
  var baseImgDispH     = 0;
  var currentRatio     = null;
  var zoomLevel        = 1;
  var rawFile          = null;
  var modalInjected    = false;
  var MIN_CROP_PX      = 44;

  function parseSize(str) {
    if (!str) return null;
    var p = str.toLowerCase().replace(/\s/g, '').split('x');
    if (p.length !== 2) return null;
    var w = parseFloat(p[0]), h = parseFloat(p[1]);
    return (w > 0 && h > 0) ? { w: w, h: h } : null;
  }

  function getActiveSize() {
    var el = document.querySelector('li.select_photo_item.select_photo_item_active');
    return el ? parseSize((el.getAttribute('item-size') || '').trim()) : null;
  }

  function ensureModal() {
    if (modalInjected) return;
    modalInjected = true;

    var style = document.createElement('style');
    style.textContent = [
      // Backdrop
      '#scm-overlay{',
        'display:none;position:fixed;inset:0;z-index:2147483647;',
        'background:rgba(0,0,0,0.72);',
        'align-items:center;justify-content:center;',
      '}',
      // Popup panel
      '#scm-modal{',
        'background:#0d1f27;border-radius:14px;',
        'width:min(92vw,820px);height:min(88vh,720px);',
        'display:flex;flex-direction:column;overflow:hidden;',
        'box-shadow:0 24px 80px rgba(0,0,0,0.6);',
        'font-family:"Montserrat",sans-serif;',
      '}',
      '#scm-header{',
        'display:flex;align-items:center;justify-content:space-between;',
        'flex-wrap:wrap;gap:8px;',
        'padding:14px 16px;flex-shrink:0;',
        'background:linear-gradient(135deg,#0d6b82,#1086A2);',
        'border-bottom:1px solid rgba(0,0,0,0.2);',
      '}',
      '#scm-title{',
        'color:#fff;font-size:14px;font-weight:700;letter-spacing:0.02em;',
        'display:flex;align-items:center;gap:8px;flex-wrap:wrap;',
        'font-family:"Montserrat",sans-serif;',
      '}',
      '#scm-sizelabel{',
        'color:rgba(255,255,255,0.8);font-size:12px;font-weight:500;',
      '}',
      '#scm-actions{display:flex;gap:8px;align-items:center;flex-shrink:0;}',
      '.scm-header-left{flex:1;min-width:0;}',
      '#scm-size-note{color:rgba(255,255,255,0.65);font-size:11px;margin-top:3px;font-family:"Hind",sans-serif;}',
      '.scm-btn{',
        'display:inline-flex;align-items:center;gap:5px;',
        'border:1px solid transparent;border-radius:8px;',
        'font-size:13px;font-weight:600;',
        'font-family:"Montserrat",sans-serif;letter-spacing:0.01em;',
        'padding:0 14px;height:36px;',
        'cursor:pointer;white-space:nowrap;',
        '-webkit-tap-highlight-color:transparent;',
        'touch-action:manipulation;',
      '}',
      '.scm-btn-ghost{background:rgba(255,255,255,0.08);color:#fff;border-color:rgba(255,255,255,0.4);}',
      '.scm-btn-ghost:hover{background:rgba(255,255,255,0.16);border-color:rgba(255,255,255,0.6);}',
      '.scm-btn-ghost:active{background:rgba(255,255,255,0.24);}',
      '.scm-btn-primary{background:#fff;color:#1086A2;border-color:#fff;}',
      '.scm-btn-primary:hover{background:rgba(255,255,255,0.9);border-color:rgba(255,255,255,0.9);}',
      '.scm-btn-primary:active{background:rgba(255,255,255,0.8);}',
      // Stage wrap — positioning parent for scrollable stage + fixed crop overlay
      '#scm-stage-wrap{position:relative;flex:1;min-height:0;min-height:200px;overflow:hidden;}',
      '#scm-stage{',
        'position:absolute;inset:0;',
        'overflow:hidden;',
        'background:rgba(255,255,255,0.55);',
        'backdrop-filter:blur(20px) brightness(4);',
        '-webkit-backdrop-filter:blur(20px) brightness(4);',
        'box-sizing:border-box;',
        'cursor:grab;',
      '}',
      '#scm-stage.scm-panning{cursor:grabbing;}',
      // Crop overlay — sits above the stage, never scrolls or scales with the image
      '#scm-crop-overlay{',
        'position:absolute;inset:0;',
        'pointer-events:none;',
        'z-index:5;',
      '}',
      // Inner shim: centres wrapper when smaller than stage, expands when zoomed
      '#scm-scroll-inner{',
        'min-width:100%;min-height:100%;',
        'display:flex;align-items:center;justify-content:center;',
        'padding:16px;box-sizing:border-box;',
      '}',
      '#scm-wrapper{',
        'position:relative;display:inline-block;',
        'line-height:0;flex-shrink:0;',
        '-webkit-user-select:none;user-select:none;',
      '}',
      '#scm-img{',
        'display:block;',
        'max-width:min(752px,calc(92vw - 64px));',
        'max-height:calc(88vh - 230px);',
        'height:auto;',
        '-webkit-user-drag:none;',
      '}',
      '#scm-img.scm-zoomed{max-width:none!important;max-height:none!important;}',
      '.scm-frost{',
        'position:absolute;',
        'background:rgba(0,0,0,0.52);',
        'pointer-events:none;',
      '}',
      '#scm-box{',
        'position:absolute;',
        'border:2px solid rgba(255,255,255,0.9);',
        'box-shadow:0 0 0 9999px rgba(0,0,0,0.52);',
        'box-sizing:border-box;',
        'pointer-events:none;',
      '}',
      '#scm-rof{position:absolute;inset:0;pointer-events:none;}',
      '.scm-rof-line{position:absolute;background:rgba(255,255,255,0.2);}',
      // Zoom bar
      '#scm-zoom-bar{',
        'display:flex;align-items:center;gap:10px;',
        'padding:10px 16px;flex-shrink:0;',
        'background:linear-gradient(135deg,#0a5d73,#0d6b82);',
        'border-top:1px solid rgba(0,0,0,0.2);',
      '}',
      '#scm-zoom-bar label{color:rgba(255,255,255,0.7);font-size:12px;white-space:nowrap;flex-shrink:0;font-family:"Hind",sans-serif;}',
      '#scm-zoom-slider{',
        'flex:1;appearance:none;-webkit-appearance:none;',
        'height:4px;border-radius:2px;',
        'background:rgba(255,255,255,0.15);',
        'outline:none;cursor:pointer;accent-color:#1086A2;',
      '}',
      '#scm-zoom-label{color:#fff;font-size:12px;font-weight:600;min-width:38px;text-align:right;flex-shrink:0;font-family:"Montserrat",sans-serif;}',
      '.scm-zoom-btn{',
        'width:30px;height:30px;border-radius:6px;',
        'background:rgba(255,255,255,0.1);color:#fff;',
        'border:none;cursor:pointer;font-size:18px;line-height:1;',
        'display:flex;align-items:center;justify-content:center;',
        'flex-shrink:0;touch-action:manipulation;',
        '-webkit-tap-highlight-color:transparent;',
      '}',
      '.scm-zoom-btn:hover{background:rgba(255,255,255,0.18);}',
      '#scm-hint{',
        'color:rgba(255,255,255,0.55);font-size:11px;',
        'padding:6px 16px 4px;text-align:center;flex-shrink:0;',
        'background:linear-gradient(135deg,#0a5d73,#0d6b82);',
        'font-family:"Hind",sans-serif;',
      '}',
      '#scm-pixelation-warning{',
        'color:#E7B63A;font-size:11px;font-weight:600;',
        'padding:4px 16px 10px;text-align:center;flex-shrink:0;',
        'background:linear-gradient(135deg,#0a5d73,#0d6b82);',
        'font-family:"Hind",sans-serif;',
      '}',
      '#scm-loading{',
        'display:none;position:absolute;inset:0;',
        'background:rgba(0,0,0,0.65);',
        'align-items:center;justify-content:center;',
        'flex-direction:column;gap:12px;color:#fff;font-size:13px;',
        'z-index:10;border-radius:4px;',
      '}',
      '#scm-spinner{',
        'width:36px;height:36px;',
        'border:3px solid rgba(255,255,255,0.2);',
        'border-top-color:#fff;',
        'border-radius:50%;',
        'animation:scm-spin 0.7s linear infinite;',
      '}',
      '@keyframes scm-spin{to{transform:rotate(360deg);}}',
      '@media(max-width:500px){',
        '#scm-modal{width:96vw;height:calc(100dvh - 48px);border-radius:14px;}',
        '#scm-header{flex-direction:column;align-items:stretch;gap:8px;padding:10px 12px;}',
        '#scm-size-note{display:none;}',
        '#scm-actions{width:100%;gap:6px;}',
        '#scm-cancel,#scm-confirm{flex:1;justify-content:center;}',
        '.scm-btn{height:40px;font-size:12px;padding:0 10px;}',
        '#scm-img{max-width:calc(96vw - 24px);max-height:calc(100dvh - 248px);}',
        '#scm-zoom-bar{padding-bottom:max(16px,env(safe-area-inset-bottom,16px));}',
        '#scm-hint{display:none;}',
      '}',
    ].join('');
    document.head.appendChild(style);

    var div = document.createElement('div');
    div.id = 'scm-overlay';
    div.innerHTML = [
      '<div id="scm-modal">',
        '<div id="scm-header">',
          '<div class="scm-header-left">',
            '<div id="scm-title">',
              'Crop your photo',
              '<span id="scm-sizelabel"></span>',
            '</div>',
            '<div id="scm-size-note">Need a different size? Close this window and reselect before uploading.</div>',
          '</div>',
          '<div id="scm-actions">',
            '<button class="scm-btn scm-btn-ghost" id="scm-rotate" type="button">',
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" ',
                'stroke="currentColor" stroke-width="2.2" ',
                'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">',
                '<polyline points="23 4 23 10 17 10"></polyline>',
                '<path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>',
              '</svg>',
              'Rotate crop',
            '</button>',
            '<button class="scm-btn scm-btn-ghost" id="scm-cancel" type="button">Cancel</button>',
            '<button class="scm-btn scm-btn-primary" id="scm-confirm" type="button">Use this crop</button>',
          '</div>',
        '</div>',
        '<div id="scm-stage-wrap">',
          '<div id="scm-stage">',
            '<div id="scm-scroll-inner">',
              '<div id="scm-wrapper">',
                '<img id="scm-img" draggable="false" alt="Your photo for cropping">',
                '<div id="scm-loading">',
                  '<div id="scm-spinner"></div>',
                  '<span>Uploading your photo…</span>',
                '</div>',
              '</div>',
            '</div>',
          '</div>',
          '<div id="scm-crop-overlay">',
            '<div class="scm-frost" id="scm-frost-t"></div>',
            '<div class="scm-frost" id="scm-frost-b"></div>',
            '<div class="scm-frost" id="scm-frost-l"></div>',
            '<div class="scm-frost" id="scm-frost-r"></div>',
            '<div id="scm-box">',
              '<div id="scm-rof">',
                '<div class="scm-rof-line" style="top:33.33%;left:0;right:0;height:1px;"></div>',
                '<div class="scm-rof-line" style="top:66.66%;left:0;right:0;height:1px;"></div>',
                '<div class="scm-rof-line" style="left:33.33%;top:0;bottom:0;width:1px;"></div>',
                '<div class="scm-rof-line" style="left:66.66%;top:0;bottom:0;width:1px;"></div>',
              '</div>',
            '</div>',
          '</div>',
        '</div>',
        '<div id="scm-zoom-bar">',
          '<label>Zoom</label>',
          '<button class="scm-zoom-btn" id="scm-zoom-out" type="button">−</button>',
          '<input type="range" id="scm-zoom-slider" min="25" max="400" value="100" step="5">',
          '<button class="scm-zoom-btn" id="scm-zoom-in" type="button">+</button>',
          '<span id="scm-zoom-label">100%</span>',
        '</div>',
        '<div id="scm-hint">Pan the photo to frame your shot · Scroll or pinch to zoom</div>',
        '<div id="scm-pixelation-warning">⚠ Zooming in too much may cause pixelation — what you see is what you\'ll get</div>',
      '</div>',
    ].join('');
    document.body.appendChild(div);

    document.getElementById('scm-cancel').addEventListener('click', closeModal);
    document.getElementById('scm-confirm').addEventListener('click', confirmCrop);
    document.getElementById('scm-rotate').addEventListener('click', rotateCrop);

    document.getElementById('scm-zoom-slider').addEventListener('input', function () {
      if (zoomAnimId) { cancelAnimationFrame(zoomAnimId); zoomAnimId = null; }
      var val = parseInt(this.value, 10) / 100;
      zoomTarget = val;
      setZoom(val);
    });
    document.getElementById('scm-zoom-out').addEventListener('click', function () {
      smoothZoomTo(zoomTarget - 0.1);
    });
    document.getElementById('scm-zoom-in').addEventListener('click', function () {
      smoothZoomTo(zoomTarget + 0.1);
    });

    // Mouse-wheel zoom on the stage — accumulate into zoomTarget, RAF animates toward it
    document.getElementById('scm-stage').addEventListener('wheel', function (e) {
      e.preventDefault();
      var delta;
      if (e.deltaMode === 1) {
        delta = e.deltaY > 0 ? -0.01 : 0.01;
      } else if (e.deltaMode === 2) {
        delta = e.deltaY > 0 ? -0.03 : 0.03;
      } else {
        var sign = e.deltaY > 0 ? -1 : 1;
        delta = sign * Math.min(Math.abs(e.deltaY) * 0.0005, 0.01);
      }
      smoothZoomTo(zoomTarget + delta);
    }, { passive: false });

    // Touch: single finger = pan, two fingers = pinch zoom
    document.getElementById('scm-stage').addEventListener('touchstart', function (e) {
      if (e.touches.length >= 2) {
        e.preventDefault();
        dragState     = null;
        touchPanState = null;
        if (zoomAnimId) { cancelAnimationFrame(zoomAnimId); zoomAnimId = null; }
        pinchState    = { dist0: getPinchDist(e.touches), zoom0: zoomLevel };
      } else if (e.touches.length === 1) {
        touchPanState = { startX: e.touches[0].clientX - panX, startY: e.touches[0].clientY - panY };
        pinchState    = null;
      }
    }, { passive: false });

    // Stage pan — click-drag to translate the image via CSS transform
    document.getElementById('scm-stage').addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      panState = { startX: e.clientX - panX, startY: e.clientY - panY };
      this.classList.add('scm-panning');
      e.preventDefault();
    }, { passive: false });
    document.addEventListener('mousemove', function (e) {
      if (!panState) return;
      panX = e.clientX - panState.startX;
      panY = e.clientY - panState.startY;
      applyPan();
    });
    document.addEventListener('mouseup', function () {
      if (panState) {
        panState = null;
        var stage = document.getElementById('scm-stage');
        if (stage) stage.classList.remove('scm-panning');
      }
    });

    document.addEventListener('touchmove',  onDragMove, { passive: false });
    document.addEventListener('touchend',   onDragEnd);

    window.addEventListener('resize', function () {
      if (document.getElementById('scm-overlay').style.display !== 'none') {
        if (zoomLevel === 1) {
          var img = document.getElementById('scm-img');
          imgDispW = img.offsetWidth;
          imgDispH = img.offsetHeight;
          baseImgDispW = imgDispW;
          baseImgDispH = imgDispH;
        }
        clampCrop();
        renderCropBox();
        renderFrost();
      }
    });
  }

  function setZoom(level) {
    zoomLevel = Math.max(0.25, Math.min(4, level));
    var img = document.getElementById('scm-img');
    if (zoomLevel === 1) {
      img.style.width  = '';
      img.style.height = '';
      img.classList.remove('scm-zoomed');
      imgDispW = img.offsetWidth;
      imgDispH = img.offsetHeight;
    } else {
      img.classList.add('scm-zoomed');
      img.style.width  = Math.round(baseImgDispW * zoomLevel) + 'px';
      img.style.height = Math.round(baseImgDispH * zoomLevel) + 'px';
      imgDispW = Math.round(baseImgDispW * zoomLevel);
      imgDispH = Math.round(baseImgDispH * zoomLevel);
    }
    var pct = Math.round(zoomLevel * 100);
    var slider = document.getElementById('scm-zoom-slider');
    var label  = document.getElementById('scm-zoom-label');
    if (slider) slider.value = pct;
    if (label)  label.textContent = pct + '%';

    // Show pixelation warning only when the customer has actively zoomed in.
    // Pixel-count thresholds only kick in above zoom >1 so we never warn about
    // a low-res source image when the customer isn't doing anything wrong.
    var warning = document.getElementById('scm-pixelation-warning');
    if (warning) {
      if (zoomLevel > 1 && imgNatW && baseImgDispW && cropState.w) {
        var estNatPx = Math.round(cropState.w * (imgNatW / (baseImgDispW * zoomLevel)));
        if (estNatPx < 800) {
          warning.textContent = '⚠ Heavy zoom — this crop has very few pixels and will likely print poorly';
          warning.style.color = '#E56B6F';
        } else {
          warning.textContent = '⚠ Zoomed in — the more you zoom, the more pixelation is possible';
          warning.style.color = '#E7B63A';
        }
      } else {
        warning.textContent = '⚠ Zooming in too much may cause pixelation — what you see is what you\'ll get';
        warning.style.color = '#E7B63A';
      }
    }

    // Crop box is in the fixed overlay — it does not move or resize with zoom
  }

  function tickZoom() {
    var diff = zoomTarget - zoomLevel;
    if (Math.abs(diff) < 0.001) {
      setZoom(zoomTarget);
      zoomAnimId = null;
      return;
    }
    setZoom(zoomLevel + diff * 0.18);
    zoomAnimId = requestAnimationFrame(tickZoom);
  }

  function smoothZoomTo(target) {
    zoomTarget = Math.max(0.25, Math.min(4, target));
    if (!zoomAnimId) zoomAnimId = requestAnimationFrame(tickZoom);
  }

  function applyPan() {
    var wrapper = document.getElementById('scm-wrapper');
    if (wrapper) wrapper.style.transform = 'translate(' + panX + 'px,' + panY + 'px)';
  }

  function openCropModal(file) {
    rawFile    = file;
    zoomLevel  = 1;
    zoomTarget = 1;
    if (zoomAnimId) { cancelAnimationFrame(zoomAnimId); zoomAnimId = null; }

    var size = getActiveSize();
    if (!size) {
      uploadFile(file);
      return;
    }
    currentRatio = { w: size.w, h: size.h };

    ensureModal();

    document.getElementById('scm-sizelabel').textContent =
      size.w + '″ × ' + size.h + '″';

    panX = 0; panY = 0;
    var img = document.getElementById('scm-img');
    img.style.width  = '';
    img.style.height = '';
    img.classList.remove('scm-zoomed');
    applyPan();
    var slider = document.getElementById('scm-zoom-slider');
    var label  = document.getElementById('scm-zoom-label');
    if (slider) slider.value = 100;
    if (label)  label.textContent = '100%';

    var url = URL.createObjectURL(file);
    img.onload = function () {
      URL.revokeObjectURL(url);
      imgNatW      = img.naturalWidth;
      imgNatH      = img.naturalHeight;
      imgDispW     = img.offsetWidth;
      imgDispH     = img.offsetHeight;
      baseImgDispW = imgDispW;
      baseImgDispH = imgDispH;
      initCrop();
    };
    img.src = url;

    document.getElementById('scm-overlay').style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeModal(keepPhoto) {
    var overlay = document.getElementById('scm-overlay');
    if (overlay) overlay.style.display = 'none';
    document.body.style.overflow = '';
    if (!keepPhoto) document.getElementById('choose_photo').value = '';
  }

  function initCrop() {
    var overlay = document.getElementById('scm-crop-overlay');
    var ow = overlay ? overlay.offsetWidth  : 700;
    var oh = overlay ? overlay.offsetHeight : 400;
    var ratio = currentRatio.w / currentRatio.h;
    // Size the crop box to 85% of the image at its initial fitted dimensions,
    // then clamp so it fits inside the overlay with a small margin
    var cw = baseImgDispW * 0.85;
    var ch = cw / ratio;
    if (ch > baseImgDispH * 0.85) { ch = baseImgDispH * 0.85; cw = ch * ratio; }
    if (cw > ow * 0.95) { cw = ow * 0.95; ch = cw / ratio; }
    if (ch > oh * 0.95) { ch = oh * 0.95; cw = ch * ratio; }
    cw = Math.max(cw, MIN_CROP_PX);
    ch = Math.max(ch, MIN_CROP_PX);
    cropState = {
      x: (ow - cw) / 2,
      y: (oh - ch) / 2,
      w: cw,
      h: ch,
    };
    renderCropBox();
    renderFrost();
  }

  function clampCrop() {
    var overlay = document.getElementById('scm-crop-overlay');
    var ow = overlay ? overlay.offsetWidth  : 700;
    var oh = overlay ? overlay.offsetHeight : 400;
    var ratio = currentRatio.w / currentRatio.h;
    cropState.w = Math.min(cropState.w, ow);
    cropState.h = cropState.w / ratio;
    if (cropState.h > oh) { cropState.h = oh; cropState.w = cropState.h * ratio; }
    cropState.w = Math.max(cropState.w, MIN_CROP_PX);
    cropState.h = Math.max(cropState.h, MIN_CROP_PX);
    cropState.x = Math.max(0, Math.min(ow - cropState.w, cropState.x));
    cropState.y = Math.max(0, Math.min(oh - cropState.h, cropState.y));
  }

  function renderCropBox() {
    var box = document.getElementById('scm-box');
    var s = cropState;
    box.style.left   = Math.round(s.x) + 'px';
    box.style.top    = Math.round(s.y) + 'px';
    box.style.width  = Math.round(s.w) + 'px';
    box.style.height = Math.round(s.h) + 'px';
  }

  function renderFrost() {
    var overlay = document.getElementById('scm-crop-overlay');
    var ow = overlay ? overlay.offsetWidth  : 700;
    var oh = overlay ? overlay.offsetHeight : 400;
    var x  = Math.round(cropState.x);
    var y  = Math.round(cropState.y);
    var w  = Math.round(cropState.w);
    var h  = Math.round(cropState.h);
    setPanel('scm-frost-t', 0,   0,    ow,         y);
    setPanel('scm-frost-b', 0,   y+h,  ow,         oh - y - h);
    setPanel('scm-frost-l', 0,   y,    x,           h);
    setPanel('scm-frost-r', x+w, y,    ow - x - w, h);
  }

  function setPanel(id, l, t, w, h) {
    var el = document.getElementById(id);
    el.style.left   = l + 'px';
    el.style.top    = t + 'px';
    el.style.width  = Math.max(0, w) + 'px';
    el.style.height = Math.max(0, h) + 'px';
  }

  function getPointer(e) {
    var src = (e.touches && e.touches.length) ? e.touches[0]
            : (e.changedTouches && e.changedTouches.length) ? e.changedTouches[0]
            : e;
    var overlay = document.getElementById('scm-crop-overlay');
    var rect = overlay.getBoundingClientRect();
    return { x: src.clientX - rect.left, y: src.clientY - rect.top };
  }

  function getPinchDist(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function onDragStart(e) {
    // Two fingers on the wrapper → pinch zoom
    if (e.touches && e.touches.length >= 2) {
      e.preventDefault();
      dragState  = null;
      pinchState = { dist0: getPinchDist(e.touches), zoom0: zoomLevel };
      return;
    }
    var box    = document.getElementById('scm-box');
    var target = e.target;
    var dir    = null;
    while (target && target !== box.parentElement) {
      if (target.dataset && target.dataset.dir) { dir = target.dataset.dir; break; }
      target = target.parentElement;
    }
    var pos = getPointer(e);
    if (dir) {
      e.preventDefault();
      dragState = { type: 'resize', dir: dir, p0: pos, s0: Object.assign({}, cropState) };
    } else if (box.contains(e.target) || e.target === box) {
      e.preventDefault();
      dragState = { type: 'move', p0: pos, s0: Object.assign({}, cropState) };
    }
  }

  function onDragMove(e) {
    // Pinch takes priority
    if (pinchState && e.touches && e.touches.length >= 2) {
      e.preventDefault();
      var newDist = getPinchDist(e.touches);
      var newZoom = Math.round(pinchState.zoom0 * (newDist / pinchState.dist0) * 100) / 100;
      zoomTarget = Math.max(0.25, Math.min(4, newZoom));
      setZoom(newZoom);
      return;
    }
    // Single-finger touch pan
    if (touchPanState && e.touches && e.touches.length === 1) {
      e.preventDefault();
      panX = e.touches[0].clientX - touchPanState.startX;
      panY = e.touches[0].clientY - touchPanState.startY;
      applyPan();
      return;
    }
    if (!dragState) return;
    e.preventDefault();
    var pos   = getPointer(e);
    var dx    = pos.x - dragState.p0.x;
    var dy    = pos.y - dragState.p0.y;
    var sc    = dragState.s0;
    var ratio = currentRatio.w / currentRatio.h;
    var nx = sc.x, ny = sc.y, nw = sc.w, nh = sc.h;

    var cropOverlay = document.getElementById('scm-crop-overlay');
    var bw = cropOverlay ? cropOverlay.offsetWidth  : 700;
    var bh = cropOverlay ? cropOverlay.offsetHeight : 400;

    if (dragState.type === 'move') {
      nx = Math.max(0, Math.min(bw - sc.w, sc.x + dx));
      ny = Math.max(0, Math.min(bh - sc.h, sc.y + dy));
    } else {
      var dir = dragState.dir;
      if      (dir === 'br') { nw = sc.w + dx; }
      else if (dir === 'bl') { nw = sc.w - dx; nx = sc.x + sc.w - nw; }
      else if (dir === 'tr') { nw = sc.w + dx; ny = sc.y + sc.h - (nw / ratio); }
      else if (dir === 'tl') { nw = sc.w - dx; nx = sc.x + sc.w - nw; ny = sc.y + sc.h - (nw / ratio); }

      nw = Math.max(MIN_CROP_PX, nw);
      nh = nw / ratio;

      if (dir === 'bl' || dir === 'tl') nx = sc.x + sc.w - nw;
      if (dir === 'tr' || dir === 'tl') ny = sc.y + sc.h - nh;

      if (nx < 0) { nx = 0; }
      if (ny < 0) { ny = 0; }
      if (nx + nw > bw) { nw = bw - nx; nh = nw / ratio; }
      if (ny + nh > bh) { nh = bh - ny; nw = nh * ratio; }
      if (dir === 'bl' || dir === 'tl') nx = sc.x + sc.w - nw;
    }

    cropState = { x: nx, y: ny, w: nw, h: nh };
    renderCropBox();
    renderFrost();
  }

  function onDragEnd() { dragState = null; pinchState = null; touchPanState = null; }

  function rotateCrop() {
    // Flip the crop aspect ratio without rotating the image
    currentRatio = { w: currentRatio.h, h: currentRatio.w };
    initCrop();
  }

  function confirmCrop() {
    var img     = document.getElementById('scm-img');
    var overlay = document.getElementById('scm-crop-overlay');

    // Where is the image on screen vs where is the overlay?
    var imgRect     = img.getBoundingClientRect();
    var overlayRect = overlay.getBoundingClientRect();
    var imgL = imgRect.left - overlayRect.left;
    var imgT = imgRect.top  - overlayRect.top;

    // Crop box in overlay-local coords
    var cx = cropState.x, cy = cropState.y;
    var cw = cropState.w, ch = cropState.h;

    // Intersection of crop box with image (the only part we can draw from)
    var ix  = Math.max(cx, imgL);
    var iy  = Math.max(cy, imgT);
    var ix2 = Math.min(cx + cw, imgL + imgDispW);
    var iy2 = Math.min(cy + ch, imgT + imgDispH);

    if (ix2 <= ix || iy2 <= iy) {
      alert('The crop box does not overlap the photo.\nZoom in or scroll the image under the crop box, then try again.');
      return;
    }

    // Map intersection → natural image pixels
    var scaleX = imgNatW / imgDispW;
    var scaleY = imgNatH / imgDispH;
    var sx = Math.max(0, Math.round((ix - imgL) * scaleX));
    var sy = Math.max(0, Math.round((iy - imgT) * scaleY));
    var sw = Math.min(Math.round((ix2 - ix) * scaleX), imgNatW - sx);
    var sh = Math.min(Math.round((iy2 - iy) * scaleY), imgNatH - sy);

    // Output canvas: exact crop-box aspect ratio, capped at the lower of 2400px
    // or the actual native pixel size of the crop region.
    // Never upscale — stretching fewer source pixels onto a larger canvas causes
    // pixelation. Upscaling with AI tools (Topaz etc.) is done manually if needed.
    var cropRatio = cw / ch;
    var maxPx = 2400;
    var nativeScale = Math.min(scaleX, scaleY); // natural px per overlay px
    var outW, outH;
    if (cropRatio >= 1) {
      outW = Math.min(maxPx, Math.round(nativeScale * cw));
      outH = Math.round(outW / cropRatio);
    } else {
      outH = Math.min(maxPx, Math.round(nativeScale * ch));
      outW = Math.round(outH * cropRatio);
    }
    var toCanvas = outW / cw;  // overlay-px → canvas-px

    var canvas = document.createElement('canvas');
    canvas.width  = outW;
    canvas.height = outH;
    var ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, outW, outH);

    // Destination rect inside canvas where the image intersection lands
    var dstX = Math.round((ix - cx) * toCanvas);
    var dstY = Math.round((iy - cy) * toCanvas);
    var dstW = Math.round((ix2 - ix) * toCanvas);
    var dstH = Math.round((iy2 - iy) * toCanvas);
    ctx.drawImage(img, sx, sy, sw, sh, dstX, dstY, dstW, dstH);

    document.getElementById('scm-loading').style.display = 'flex';

    canvas.toBlob(function (blob) {
      if (!blob) {
        console.error('[Signet Crop] toBlob failed — falling back to raw upload');
        document.getElementById('scm-loading').style.display = 'none';
        closeModal();
        uploadFile(rawFile);
        return;
      }
      var croppedFile = new File([blob], rawFile.name, { type: 'image/jpeg' });
      uploadFile(croppedFile, true);
    }, 'image/jpeg', 0.95);
  }

  function uploadFile(file, wasCropped) {
    var $doc = $(document);
    $doc.find('.addLoader').addClass('it_loading');
    $doc.find('.photo_uploaded_successfully').css('display', 'none');
    $doc.find('.choose_photo_remove').css('display', 'none');

    var rno = $doc.find('#random_number').val();
    var uploadFnUrl = (window.signetProductConfig && window.signetProductConfig.preorderUploadUrl)
      || 'https://signet-operations-portal.netlify.app/.netlify/functions/get-preorder-upload-url';

    fetch(uploadFnUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ rno: String(rno) })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Failed to get upload URL');
      return res.json();
    })
    .then(function (urlData) {
      return fetch(urlData.uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': 'image/jpeg' },
        body: file
      }).then(function (putRes) {
        if (!putRes.ok) throw new Error('S3 upload failed');
        // Return both the key (stored in _Upload Photo) and the presigned URL (for UI preview).
        // Key is short + never expires; presigned URL expires in 7 days and is too long for
        // reliable Shopify→GraphQL→DynamoDB round-trip.
        return { key: urlData.key, fileUrl: urlData.fileUrl };
      });
    })
    .then(function (upload) {
      var loading = document.getElementById('scm-loading');
      if (loading) loading.style.display = 'none';
      closeModal(true);

      var ths_id       = 'PHOTOREQUEST';
      var orderType    = $doc.find('li.select_item_type__item.select_item_type__item_active').attr('item-name');
      var photoSize    = $.trim($doc.find('li.select_photo_item.select_photo_item_active').attr('item-size'));
      var anotherOrder = $('.order_type_list_label.custom_select_option_label.check_order_type').attr('type-name');

      $doc.find('#itg_properties_data').html('');
      $doc.find('#upload_photo').val(upload.fileUrl);
      setPhotoIdValue($doc.find('.photo_id_button'), 'PHOTOREQUEST');
      $doc.find('#valid_btn_submit').removeClass('btn_check_status');
      $doc.find('#choose_photo').attr('data-imgfinal', upload.key);

      var props = [
        ['Choose Order', anotherOrder],
        ['Order Type',   orderType],
        ['Photo Size',   photoSize],
        ['Photo ID',     ths_id],
        ['_Upload Photo', upload.key],
      ];
      if (wasCropped) props.push(['_Photo Cropped', 'Yes']);

      props.forEach(function (p) {
        $doc.find('#itg_properties_data').append(
          '<input type="hidden" name="properties[' + p[0] + ']" value="' + p[1] + '">'
        );
      });

      $doc.find('.choose_photo_remove').css('display', 'inline-flex');
      $doc.find('.photo_uploaded_successfully').css('display', 'flex');
      $doc.find('.select_ink_color_wrapper').removeClass('itg_disable_items');
      $doc.find('.addLoader').removeClass('it_loading');
      if (typeof cal_price === 'function') cal_price(0);
    })
    .catch(function () {
      var loading = document.getElementById('scm-loading');
      if (loading) loading.style.display = 'none';
      closeModal();
      $doc.find('.addLoader').removeClass('it_loading');
      $doc.find('#choose_photo').val('');
      alert('Photo upload failed. Please try again or contact support.');
    });
  }

  window.SignetCrop = { open: openCropModal };

}());

$(document).ready(function() {

    // Gallery back-to-top button — appended directly to body so position:fixed is always viewport-relative
    var $galleryTopBtn = $('<button id="signet-gallery-top-btn" class="signet-gallery-top-btn">&#8593; Back to Top</button>').hide().appendTo('body');
    $galleryTopBtn.on('click', function() {
      var els = [
        document.querySelector('.photo_gallery_popup'),
        document.querySelector('.photo_from_gallery_box'),
        document.querySelector('.photo_gallery_popup .page-width'),
      ];
      els.forEach(function(el) { if (el) el.scrollTop = 0; });
      window.scrollTo(0, 0);
    });

    $(window).keydown(function(event){
        if(event.keyCode == 13) {
          event.preventDefault();
          return false;
        }
    });

    window.addEventListener("pageshow", function ( event ) {
        var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
        if(historyTraversal ) {
          window.location.reload();
        }
    });
 
   function empty_sel() {
      $(document).find('.select_item_type__grid .select_item_type__item').removeClass("select_item_type__item_active");
      $(document).find(".select_photo_item").removeClass("select_photo_item_active");
      $(document).find(".funko_pop_grid_item").removeClass("funko_pop_grid_item_active");
      $(document).find('#tmp-28_checkbox').prop('checked', false);
      setPhotoIdValue($(document).find(".photo_id_button"), '');
      $(document).find("#ink_color").attr('name','');
      $(document).find("#ink_color").val('');
      $(document).find("#itg_properties_data").html('');
      $(document).find('.itg_disable_find').addClass('itg_disable_items');
      $(document).find('#choose_photo').val('');
      $(document).find('#valid_btn_submit').addClass('btn_check_status');
      $(document).find('.autograph_add_ons_wrapper').addClass('itg_autograph_add_ons_wrapper');
      $(document).find(".photo_uploaded_successfully").css("display", "none");
      $(document).find(".choose_photo_remove").css("display", "none");
      $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
      $(document).find(".select_ink_color_heading").text('Select Ink Color');
      $(document).find(".select_ink_color_label").removeClass("drop_down_active");
      $(document).find(".select_ink_color_label").removeClass("active-link-color");
      $(document).find(".custom_color_ink").removeClass("drop_down_active");
      $(document).find("#ink_color").attr('name','');
      $(document).find("#ink_color").val('');
      $(document).find("#custom_ink_color").val('');
      $(document).find(`#itg_properties_data input[name="properties[Ink Color]"]`).remove();
      $(document).find(".existing_signet_order_label").removeClass("check_caste_piece drop_down_active");
      $(document).find('.itg_steps_box_grid_item_buttons .steps_box_button').removeClass('steps_box_button_active');
      $(document).find('#funko_pop_flat').removeClass('steps_box_grid_funko_pop_active');
      $(document).find('#heading_cast_price').hide();
      $(document).find('#heading_cast_price').attr('data-set','0');
      $(document).find('#field_detailed_description').attr('name','');
      $(document).find('#field_detailed_description').val('');
      $(document).find('.step_box_disclaimer').hide();
      $(document).find('#field_name_order_number').val('');
      $(document).find(`#itg_properties_data input[name="properties[Previous Order Number]"]`).remove();
          
          /* ---------- */
             $(document).find(".send_in_item_type_heading").text('Select your item');
             $(document).find(".itg_box_grid").each(function(index) {
                $(this).removeClass('steps_box_grid_active');
             });
             $(document).find("ul#signet_order_type_items li").each(function(index) {
                $(this).removeClass('drop_down_active');
             });
            $(document).find('.personal_pro').remove();
            $(document).find("ul.steps_box_grid_tranding_cards").removeClass('steps_box_grid_active');
            $(document).find("ul.steps_box_grid_comix_book_or_magazine").removeClass('steps_box_grid_active');
            $(document).find("ul.steps_box_grid_tranding_cards li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('.step_first_trade').removeClass('trade_active_first');
               $(document).find('.step_second_trade').removeClass('trade_active_second');
               $(document).find('.step_third_trade').removeClass('trade_active_third');
               $(document).find('.steps_box_grid_item_price_added').hide();
               if(index != 0){
                 $(this).hide();
               }
            });
            $(document).find("ul.steps_box_grid_comix_book_or_magazine li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('.step_first_book').removeClass('book_active_first');
               $(document).find('.step_second_book').removeClass('book_active_second');
               $(document).find('.step_third_book').removeClass('book_active_third');
               $(document).find('.steps_box_grid_item_price_added').hide();
               if(index != 0){
                 $(this).hide();
               }
            });
            $(document).find("ul.itg_sending_steps_box_grid_funko_pop li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('button').removeClass('personal_active');
               $(this).find('.step_box_disclaimer').hide();
            });
            $(document).find("ul.steps_box_grid_photo_and_flats_larger_than li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('button').removeClass('personal_active');
               $(this).find('.step_box_disclaimer').hide();
            });
           /* ---------- */

          // JSA reset
          $(document).find('.jsa_no_btn').addClass('jsa_toggle_active');
          $(document).find('.jsa_yes_btn').removeClass('jsa_toggle_active');
          $(document).find('.jsa_options_head').hide();
          $(document).find('.jsa_tier_item').removeClass('jsa_tier_active');
          $(document).find('.jsa_witness_placement_head').hide();
          $(document).find('.jsa_placement_btn').removeClass('jsa_placement_active');
          $(document).find('#jsa_price_checkbox').prop('checked', false).attr('data-addons', '0');
          $(document).find(`#itg_properties_data input[name="properties[JSA Authentication]"]`).remove();
          $(document).find(`#itg_properties_data input[name="properties[JSA Sticker Placement]"]`).remove();
          // Signet Seal reset
          $(document).find('.seal_optin_head').hide();
          $(document).find('.seal_placement_head').hide();
          $(document).find('.seal_no_btn').addClass('seal_toggle_active');
          $(document).find('.seal_yes_btn').removeClass('seal_toggle_active');
          $(document).find('.seal_placement_btn').removeClass('seal_placement_active');
          $(document).find(`#itg_properties_data input[name="properties[Signet Seal]"]`).remove();

   }
   function addons_check() {
       $(document).find(".add_on__head .add_on_name_head").each(function() {
          $(this).find('.promoted-input-checkbox').prop('checked', false);
          $(this).find('.itg_add_on_field').removeClass('add_on_field_active');
          $(this).find('.itg_add_on_field').attr('name','');
          $(this).find('.itg_add_on_field').val('');
       });
       $(document).find('#field_location').attr('name','');
       $(document).find('#field_location').val('');
     
   }
   function defult_cal() {
      var totalPrice = 0;
      var main_symbol = $(document).find('.itg_main_product_temp').attr('data-sym');
      totalPrice += parseFloat($(document).find('.itg_custom_price').attr('data-mainprice'));
      $(document).find(".itg_custom_price").text(main_symbol+totalPrice.toFixed(2));
      $(document).find(".itg_custom_price").attr('data-orignalprice',totalPrice.toFixed(2));
   }
   function cal_price(addprice) {
       var totalPrice = 0;
       var main_symbol = $(document).find('.itg_main_product_temp').attr('data-sym');
       totalPrice += parseFloat($(document).find('.itg_custom_price').attr('data-mainprice'));
       var funkoPrice = $(document).find('li.funko_pop_grid_item.funko_pop_grid_item_active').attr('data-funko');
         if(funkoPrice){
           totalPrice += parseFloat(funkoPrice);
         }else{
           totalPrice += parseFloat(addprice);
         }
       var selPhoto = $(document).find('#choose_photo').val();
         if(selPhoto){
           
           var photosizePrice = $(document).find('li.select_photo_item.select_photo_item_active').attr('size-price'); 
           totalPrice += parseFloat(photosizePrice);
           
           totalPrice += parseFloat($(document).find('#choose_photo').attr('upload-price'));
           
         }else{
             var photo_id_price = getPhotoIdValue($(document).find(".photo_id_button"));
             if(photo_id_price){
               var photosizePrice = $(document).find('li.select_photo_item.select_photo_item_active').attr('size-price');
               totalPrice += parseFloat(photosizePrice);
             }else{
               totalPrice += parseFloat(addprice);
             }
         }
       $(document).find(".itg_checkbox_price:checked").each(function() {
         var adone_val = $(this).attr('data-addons');
         if(adone_val){
           totalPrice += parseFloat(adone_val);
         }else{
           totalPrice += parseFloat(addprice);
         }
       });

       var castePiece = $(document).find('.check_caste_piece').attr('item-caseprice');
       if(castePiece){
          totalPrice += parseFloat(castePiece);
       }else{
         totalPrice += parseFloat(addprice);
       }

       var castePiece_funko = $(document).find('.steps_box_button_active').attr('data-flat');
       if(castePiece_funko){
          totalPrice += parseFloat(castePiece_funko);
       }else{
         totalPrice += parseFloat(addprice);
       }

       var add_castePiece = $(document).find('#heading_cast_price').attr('data-set');
       if(add_castePiece == 1){
           $(document).find('#itg_properties_data input[name="properties[Adding Cast Piece]"]').remove();
           var add_castePiece_cal = $(document).find('#heading_cast_price').attr('data-setprice');
           var adding_price = '$'+add_castePiece_cal;
           totalPrice += parseFloat(add_castePiece_cal);
           $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="properties[Adding Cast Piece]" value="${adding_price}">`);
       }else{
         totalPrice += parseFloat(addprice);
         $(document).find('#itg_properties_data input[name="properties[Adding Cast Piece]"]').remove();
       }

       var signet_cast_price = $(document).find('.signet_cast_price').attr('item-caseprice');
       if(signet_cast_price){
          totalPrice += parseFloat(signet_cast_price);
       }else{
         totalPrice += parseFloat(addprice);
       }

       $(document).find("ul.steps_box_grid_tranding_cards li").each(function() {
         var adone_val = $(this).attr('data-cprice');
         if(adone_val){
           totalPrice += parseFloat(adone_val);
         }else{
           totalPrice += parseFloat(addprice);
         }
       });
       $(document).find("ul.steps_box_grid_comix_book_or_magazine li").each(function() {
         var adone_val = $(this).attr('data-cprice');
         if(adone_val){
           totalPrice += parseFloat(adone_val);
         }else{
           totalPrice += parseFloat(addprice);
         }
       });
       $(document).find("ul.itg_sending_steps_box_grid_funko_pop li").each(function() {
         var adone_val = $(this).attr('data-cprice');
         if(adone_val){
           totalPrice += parseFloat(adone_val);
         }else{
           totalPrice += parseFloat(addprice);
         }
       });

       $(document).find("ul.steps_box_grid_photo_and_flats_larger_than li").each(function() {
         var adone_val = $(this).attr('data-cprice');
         if(adone_val){
           totalPrice += parseFloat(adone_val);
         }else{
           totalPrice += parseFloat(addprice);
         }
       });
     
      $(document).find(".itg_custom_price").text(main_symbol+totalPrice.toFixed(2));
      $(document).find(".itg_custom_price").attr('data-orignalprice',totalPrice.toFixed(2));
   }

  //Start-same_data
      $(document).on("click", ".select_ink_color_heading_head", function () {
          $(".select_ink_color_label,.custom_color_ink").toggleClass("drop_down_active");
      });
      $(document).on("click", ".select_ink_color_label", function () {
        $(document).find(".select_ink_color_heading").text($(this).text());
        $(document).find(".select_ink_color_label").removeClass("drop_down_active");
        if(!$('.select_ink_color_label').hasClass('drop_down_active')){
            $(".custom_color_ink").removeClass("drop_down_active");
        }
        $(document).find("#custom_ink_color").val('');
        var ink_name = $(this).attr('ink-name');
        $(document).find("#ink_color").attr('name','properties[Ink Color]');
        $(document).find("#ink_color").val(ink_name);
        $(document).find(`#itg_properties_data input[name="properties[Ink Color]"]`).remove();
        $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Ink Color]" value="${ink_name}">`);
      });
     $(document).on("click", "#custom_ink_color_btn", function () {
        var colorInput = $(this).closest('.custom_color_ink').find('#custom_ink_color').val();
        if(colorInput){
            $(document).find(".select_ink_color_heading").text(colorInput);
            $(document).find(".select_ink_color_label").removeClass("drop_down_active");
            $(document).find(".custom_color_ink").removeClass("drop_down_active");
            $(document).find("#ink_color").attr('name','properties[Ink Color]');
            $(document).find("#ink_color").val(colorInput);
            $(document).find(`#itg_properties_data input[name="properties[Ink Color]"]`).remove();
            $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Ink Color]" value="${colorInput}">`);
            $(this).closest(".custom_color_ink").addClass("active-link-color");
        }else{
          alert('Enter color name');
          return false;
        }
      });
      $(document).find(".add_on__head_fields").each(function() {
        let checkbox = $(this).find(".promoted-input-checkbox");
        let addOnField = $(this).find(".add_on_field");
        if(checkbox.length && addOnField.length){
          checkbox.on("change", function () {
            addOnField.toggleClass("add_on_field_active", checkbox.is(":checked"));
             if($(this).is(':checked')){
               cal_price(addprice = 0);
             }else{
               
                $(addOnField).attr('name','');
                $(addOnField).val('');
                let thsPro = $(addOnField).attr('data-pro');
                $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                cal_price(addprice = 0);
             }
          });
        }
       });
       $(document).on("change keyup input","#character_name",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
               var _chrLimit = parseInt($(this).attr('data-limit')) || 0;
               if(_chrLimit > 0){
                 var words = inputVal.trim().split(/\s+/);
                 if(words.length > _chrLimit){
                   var thsword = words.slice(0, _chrLimit).join(' ');
                   $(this).val(thsword);
                   $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                   $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${thsword}">`);
                 }
               }
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
       $(document).on("change keyup input","#quote",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
               var _quoteLimit = parseInt($(this).attr('data-limit')) || 0;
               if(_quoteLimit > 0){
                 var words = inputVal.trim().split(/\s+/);
                 if(words.length > _quoteLimit){
                   var thsword = words.slice(0, _quoteLimit).join(' ');
                   $(this).val(thsword);
                   $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                   $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${thsword}">`);
                 }
               }
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
       $(document).on("change keyup input","#personalization_details",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               var thsPrice = $(this).closest('.add_on_name_head').find(`input[type="checkbox"]`).attr('data-addons');
               //var addStr = '-$'+thsPrice;
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
       $(document).on("change keyup input","#remarque",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
       $(document).on("change keyup input","#headshot",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
       $(document).on("change keyup input","#bust",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
       $(document).on("change keyup input","#full_body",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
       $(document).on("change keyup input","#custom_addon_1,#custom_addon_2,#custom_addon_3",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
               $(this).val(inputVal);
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
               var _limit = parseInt($(this).attr('data-limit')) || 0;
               if(_limit > 0){
                 var words = inputVal.trim().split(/\s+/);
                 if(words.length > _limit){
                   var thsword = words.slice(0, _limit).join(' ');
                   $(this).val(thsword);
                   $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                   $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${thsword}">`);
                 }
               }
            }else{
              $(this).val('');
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            }
            cal_price(addprice = 0);
       });
       $(document).on("change keyup input","#field_location",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
             $(this).attr('name',thsPro);
              $(this).val(inputVal);
            }else{
              $(this).attr('name','');
              $(this).val('');
            }
            cal_price(addprice = 0);
       });
  //End-same_data
  
   function signet_items() {
          /* Start-what-type-of-item-would-you-like-to-order */
          $(document).on("click",".select_item_type__grid .select_item_type__item",function() {
               $(document).find('.itg_disable_find').addClass('itg_disable_items');
               $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
               $(document).find(".select_ink_color_heading").text('Select Ink Color');
			   $(document).find("#ink_color").attr('name','');
			   $(document).find("#ink_color").val('');
			   $(document).find("#custom_ink_color").val('');
            
               $(document).find('.select_item_type__grid .select_item_type__item').removeClass("select_item_type__item_active");
               $(this).addClass('select_item_type__item_active');
               let itemTypeValue = $(this).attr("item-type");
               $(document).find(".item_type_content").each(function() {
                 let itemContentValue = $(this).attr("item-type-content");
                 $(this).toggleClass("item_type_content_active", itemTypeValue === itemContentValue);
                 $(this).removeClass("itg_disable_items", itemTypeValue === itemContentValue);
               });
               $(document).find(".select_photo_item").removeClass("select_photo_item_active");
               $(document).find(".funko_pop_grid_item").removeClass("funko_pop_grid_item_active");
               setPhotoIdValue($(document).find(".photo_id_button"), '');
               $(document).find('#valid_btn_submit').addClass('btn_check_status');
               cal_price(addprice = 0);
          });
         /* End-what-type-of-item-would-you-like-to-order */
     
         /* Start-what-photo-size-would-you-like */
               $(document).on("click","ul.select_photo_size_price_grid li.select_photo_item",function() {
                     
                     $(document).find(".photo_uploaded_successfully").css("display", "none");
                     $(document).find(".choose_photo_remove").css("display", "none");
                     $(document).find(".select_photo_item").removeClass("select_photo_item_active");
                     $(this).addClass('select_photo_item_active');
                     $(document).find(".photo_from_gallery_head").addClass("photo_gallery_popup");
                     $('body').addClass('signet-gallery-open');
                     $galleryTopBtn.show();
                     //let itemSize = $.trim($(this).attr("item-size"));
                     let itemSize = $.trim($(this).attr("item-sizesel"));
                     /* 8x10, 11x14 and 16x20 all resolve to the 08x10 panel (see the
                        item-sizesel ternary in signet-preorder-ofs.liquid) because one
                        gallery currently serves all three. That makes the panel's own
                        Liquid <h2> a lie for two of the three sizes, so the heading is
                        written from the size the customer actually clicked. item-size is
                        the real label ("08x10 "); the leading zero is dropped to match
                        the "Select Your 8x10 Photo" wording the <h2> already used. */
                     let itemSizeLabel = $.trim($(this).attr("item-size")).replace(/^0+/, '');
                     $(document).find(".photo_from_gallery_inner").each(function() {
                       let photoGalleryInnerValue = $(this).attr("gallery-photo");
                       let isActivePanel = itemSize === photoGalleryInnerValue;
                       $(this).toggleClass("photo_gallery_inner_active", isActivePanel);
                       if (isActivePanel && itemSizeLabel) {
                         $(this).find("h2.heading_big").text('Select Your ' + itemSizeLabel + ' Photo');
                       }
                     });
                     setPhotoIdValue($(document).find(".photo_id_button"), '');
                     $(document).find('#choose_photo').val('');
                     $(document).find("#main_photo_artwork").css("display", "none");
                     $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
                     $(document).find(".select_ink_color_heading").text('Select Ink Color');
                     $(document).find(".select_ink_color_label").removeClass("drop_down_active");
                     $(document).find(".custom_color_ink").removeClass("drop_down_active");
      			     $(document).find("#ink_color").attr('name','');
      			     $(document).find("#ink_color").val('');
      			     $(document).find("#custom_ink_color").val('');
                     $(document).find('#valid_btn_submit').addClass('btn_check_status');
                     cal_price(addprice = 0);
               });
               $(document).on("click",".itg_photo_from_gallery__item",function() {
                 var ths_id = $(this).attr('data-imgid');
                 setPhotoIdValue($(document).find(".photo_id_button"), ths_id);
                 $(document).find(".photo_from_gallery_head").removeClass("photo_gallery_popup");
                 $('body').removeClass('signet-gallery-open');
                 $galleryTopBtn.hide();
                   if(ths_id){
                     $(document).find('.select_ink_color_wrapper').removeClass('itg_disable_items');
                     $(document).find("#itg_properties_data").html('');
                     $(document).find('#valid_btn_submit').removeClass('btn_check_status');
                     var orderType = $(document).find('li.select_item_type__item.select_item_type__item_active').attr('item-name');
                     var photoSize = $.trim($(document).find('li.select_photo_item.select_photo_item_active').attr('item-size'));
                     //var photoSize_pro = $(document).find('li.select_photo_item.select_photo_item_active').attr('item-selpro');

                     let anotherOrderType = $('.order_type_list_label.custom_select_option_label.check_order_type').attr("type-name");

                     $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Choose Order]" value="${anotherOrderType}">`);
                     
                     $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Order Type]" value="${orderType}">`);
                     $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Photo Size]" value="${photoSize}">`);
                     $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Photo ID]" value="${ths_id}">`);
                      cal_price(addprice = 0);
                   }
               });
               $(document).on("click",".itg_upload_your_image",function() {
                   $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
                   $(document).find(".select_ink_color_heading").text('Select Ink Color');
    			   $(document).find("#ink_color").attr('name','');
    			   $(document).find("#ink_color").val('');
    			   $(document).find("#custom_ink_color").val('');
                   $(document).find("#main_photo_artwork").css("display", "block");
                   setPhotoIdValue($(document).find(".photo_id_button"), '');
                   $(document).find(".photo_from_gallery_head").removeClass("photo_gallery_popup");
                   $('body').removeClass('signet-gallery-open');
                   $galleryTopBtn.hide();
                   let heightFromBodyToDiv = $(document).find('#main_photo_artwork').height();
                   $('html, body').animate({
                      scrollTop: $('#main_photo_artwork').offset().top - heightFromBodyToDiv
                   }, 'slow');
                   cal_price(addprice = 0);
               });
               $(document).on("click",".available_photos_btn",function() {
                   $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
                   $(document).find(".select_ink_color_heading").text('Select Ink Color');
    			   $(document).find("#ink_color").attr('name','');
    			   $(document).find("#ink_color").val('');
    			   $(document).find("#custom_ink_color").val('');
                   $(document).find('#choose_photo').val('');
                   $(document).find("#itg_properties_data").html('');
                   $(document).find("#main_photo_artwork").css("display", "none");
                   setPhotoIdValue($(document).find(".photo_id_button"), '');
                   let heightFromBodyToDiv = $(document).find('.select_photo_size_price_head').height();
                   $('html, body').animate({
                      scrollTop: $('.select_photo_size_price_head').offset().top - heightFromBodyToDiv
                   }, 'slow');
                   $(document).find('#valid_btn_submit').addClass('btn_check_status');
                   cal_price(addprice = 0);
               });
               $(document).on("click",".cross-icon",function() {
                  $(document).find(".photo_from_gallery_head").removeClass("photo_gallery_popup");
                  $('body').removeClass('signet-gallery-open');
                  $galleryTopBtn.hide();
               });
               $(document).on("change", "#choose_photo", function () {
                if ($(this).val() !== '') {
                    var file = $('#choose_photo').prop('files')[0];
                    if (!file) return;
                    if (!file.type.match(/^image\/jpe?g$/i)) {
                      alert('Only JPEG/JPG files are accepted.');
                      $(this).val('');
                      return;
                    }
                    if (file.size > 15 * 1024 * 1024) {
                      alert('File is too large. Maximum size is 15MB.');
                      $(this).val('');
                      return;
                    }
                    SignetCrop.open(file);
                }
           });
             $(document).on("click",".choose_photo_remove",function() {
                $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
                 $(document).find(".select_ink_color_heading").text('Select Ink Color');
    			 $(document).find("#ink_color").attr('name','');
    			 $(document).find("#ink_color").val('');
    			$(document).find("#custom_ink_color").val('');
                $(document).find('#choose_photo').val('');
                setPhotoIdValue($(document).find(".photo_id_button"), '');
                $(document).find(".photo_uploaded_successfully").css("display", "none");
                $(document).find('#valid_btn_submit').addClass('btn_check_status');
                $(document).find(".choose_photo_remove").css("display", "none");
                cal_price(addprice = 0);
             });
         /* End-what-photo-size-would-you-like */
     
         /* Start-funko-pop-poster */
           $(document).on("click",".funko_pop_grid_item",function() {
                $(document).find('.select_ink_color_wrapper').removeClass('itg_disable_items');
                $(document).find("#itg_properties_data").html('');
                $(document).find(".funko_pop_grid_item").removeClass("funko_pop_grid_item_active");
                $(this).addClass("funko_pop_grid_item_active");
                //var addprice = $(this).attr("data-funko");
                $(document).find('#valid_btn_submit').removeClass('btn_check_status');
                var orderType = $(document).find('li.select_item_type__item.select_item_type__item_active').attr('item-name');
                var itemName = $(this).attr("data-itemname");
                var funkoName__pro = $(this).attr("item-selpro");
                let anotherOrderType = $('.order_type_list_label.custom_select_option_label.check_order_type').attr("type-name");

                $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Choose Order]" value="${anotherOrderType}">`); 
                $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Order Type]" value="${orderType}">`);
                $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Item Name]" value="${itemName}">`);
                cal_price(addprice = 0);
           });
         /* End-funko-pop-poster */
   }

   function signet_existing_order() {
        $(document).find('#valid_btn_submit').addClass('btn_check_status');
        $(document).find("#itg_properties_data").html('');
        $(document).find(".existing_signet_order_head").addClass("itg_disable_items");
        $(document).find(".existing_signet_order_heading").text('Select your item');
        $(document).on("change keyup input","#field_name_order_number",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            if(inputVal){
              $(document).find("#itg_properties_data").append(`<input type="hidden" name="${thsPro}" value="${inputVal}">`);
              $(document).find(".existing_signet_order_head").removeClass("itg_disable_items");
            }else{
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find(".existing_signet_order_head").addClass("itg_disable_items");
               $(document).find(".existing_signet_order_heading").text('Select your item');
               $(document).find(".existing_signet_order_label").removeClass("check_caste_piece");
               $(document).find('.itg_steps_box_grid_item_buttons .steps_box_button').removeClass('steps_box_button_active');
               $(document).find('#funko_pop_flat').removeClass('steps_box_grid_funko_pop_active');
               $(document).find(".existing_signet_order_label").removeClass("drop_down_active");
                     $(document).find("#ink_color").attr('name','');
      			     $(document).find("#ink_color").val('');
                     $(document).find('.select_ink_color_wrapper').addClass('itg_disable_items');
                     $(document).find(".select_ink_color_heading").text('Select Ink Color');
                     $(document).find("#custom_ink_color").val('');
                     $(document).find(".custom_color_ink").removeClass("drop_down_active");
            }
            cal_price(addprice = 0);
        });
        
         /* startWhat type of item is your caste piece? */
           $(document).on("click",".itg_steps_box_grid_item_buttons .steps_box_button",function() {
               $(document).find('.itg_steps_box_grid_item_buttons .steps_box_button').removeClass('steps_box_button_active');
               $(this).addClass('steps_box_button_active');
               $(document).find('.step_box_disclaimer').show();
               cal_price(addprice = 0);
               var funkopopup_flat_name = $(this).attr('data-name');
               if(funkopopup_flat_name){
                 var funkopopup_flat_val = $(this).attr('data-flatname');
                 //$(document).find(`#itg_properties_data input[name="${funkopopup_flat_name}"]`).remove();
                 //$(document).find("#itg_properties_data").append(`<input type="hidden" name="${funkopopup_flat_name}" value="${funkopopup_flat_val}">`);
               }
           });
         /* end-What type of item is your caste piece? */
   }
     //Start-select-item-signet_existing_order
      if($(document).find('.existing_signet_order_heading_head').length > 0){
          $(document).on("click",".existing_signet_order_heading_head",function() {
            $(document).find(".existing_signet_order_label").toggleClass("drop_down_active");
         });
         $(document).on("click",".existing_signet_order_label",function() {

           // additional charge add on js
          
           if($(".additional_charge_add_on #additional_charge_checkbox").is(":checked")) {
             $(".additional_charge_add_on #additional_charge_checkbox").prop("checked",false) ;
           }

          // additional charge add on js
           
            //$(document).find(".existing_signet_order_label").removeClass("drop_down_active check_caste_piece");
            $(document).find('.step_box_disclaimer').hide();
            $(document).find('.itg_steps_box_grid_item_buttons .steps_box_button').removeClass('steps_box_button_active');
            $(".existing_signet_order_label").removeClass("drop_down_active check_caste_piece");
            $(this).addClass('check_caste_piece');
            $(document).find(".existing_signet_order_heading").text($(this).text());
            
            var thsPro = $.trim($(this).attr('data-name'));
            var inputVal = $.trim($(this).attr('data-title'));
            var splitValue = inputVal.split('-');
            var inputVal = splitValue[0];
            $(document).find(`#itg_properties_data input[name="properties[Funko POP Sent]"]`).remove();
            $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
            $(document).find("#itg_properties_data").append(`<input type="hidden" name="${thsPro}" value="${inputVal}">`);
           
            if($(this).hasClass("stepbox_funko_pop")) {
              $(document).find(".send_in_item_type_head").addClass("send_in_item_type_head_active");
              $(document).find(".existing_signet_order_head").addClass("existing_signet_order_head_active");
              $(document).find(".steps_box_grid_funko_pop").addClass("steps_box_grid_funko_pop_active");
            }else{
              $(document).find(".send_in_item_type_head").removeClass("send_in_item_type_head_active");
              $(document).find(".existing_signet_order_head").removeClass("existing_signet_order_head_active");
              $(document).find(".steps_box_grid_funko_pop").removeClass("steps_box_grid_funko_pop_active");
            }
            $(document).find('.select_ink_color_wrapper').removeClass('itg_disable_items');
            cal_price(addprice = 0);
            $(document).find('#valid_btn_submit').removeClass('btn_check_status');
         });

         
      }
   //End-select-item-signet_existing_order

      //Start-Please-Provide-a-detailed-description-of-youritem
       $(document).on("change keyup input","#field_detailed_description",function() {
            var inputVal = $(this).val();
            var thsPro = $.trim($(this).attr('data-pro'));
            if(inputVal){
              $(this).attr('name',thsPro);
              $(this).val(inputVal);
            }else{
              $(this).attr('name','');
              $(this).val('');
            }
            cal_price(addprice = 0);
       });
     //End-Please-Provide-a-detailed-description-of-youritem

    function signet_order_type() {
        //console.log('Test Data');
    }

   //Start-select-item-signet_order_type
     if($(document).find('.send_in_item_type_heading_head').length > 0){
        $(document).on('click','.send_in_item_type_heading_head',function() {
          $(document).find(".send_in_item_type_label").toggleClass("drop_down_active");
        });
        $(document).on('click','.send_in_item_type_label',function() {

           // additional charge add on js
          
           if($(".additional_charge_add_on #additional_charge_checkbox").is(":checked")) {
             $(".additional_charge_add_on #additional_charge_checkbox").prop("checked",false) ;
           }

          // additional charge add on js
          
           /* ---------- */
           $(document).find('.personal_pro').remove();
            $(document).find("ul.steps_box_grid_tranding_cards").removeClass('steps_box_grid_active');
            $(document).find("ul.steps_box_grid_comix_book_or_magazine").removeClass('steps_box_grid_active');
            $(document).find("ul.steps_box_grid_tranding_cards li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('.step_first_trade').removeClass('trade_active_first');
               $(document).find('.step_second_trade').removeClass('trade_active_second');
               $(document).find('.step_third_trade').removeClass('trade_active_third');
               $(document).find('.steps_box_grid_item_price_added').hide();
               if(index != 0){
                 $(this).hide();
               }
            });
            $(document).find("ul.steps_box_grid_comix_book_or_magazine li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('.step_first_book').removeClass('book_active_first');
               $(document).find('.step_second_book').removeClass('book_active_second');
               $(document).find('.step_third_book').removeClass('book_active_third');
               $(document).find('.steps_box_grid_item_price_added').hide();
               if(index != 0){
                 $(this).hide();
               }
            });
            $(document).find("ul.itg_sending_steps_box_grid_funko_pop li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('button').removeClass('personal_active');
               $(this).find('.step_box_disclaimer').hide();
            });
            $(document).find("ul.steps_box_grid_photo_and_flats_larger_than li").each(function(index) {
               $(this).attr('data-cprice',0);
               $(document).find('button').removeClass('personal_active');
               $(this).find('.step_box_disclaimer').hide();
            });
           /* ---------- */
          
            $(document).find(".send_in_item_type_label").removeClass("drop_down_active");
            $(document).find(".steps_box_grid").removeClass("steps_box_grid_active");
            $(document).find(".send_in_item_type_head").removeClass("send_in_item_type_head_active");
            $(document).find(".send_in_item_type_heading").text($(this).text());
          
              if($(this).hasClass("stepbox_trading_cards")) {
                $(document).find(".steps_box_grid_tranding_cards").addClass("steps_box_grid_active");
              }else if ($(this).hasClass("stepbox_comix_book_or_magazine")) {
                $(document).find(".steps_box_grid_comix_book_or_magazine").addClass("steps_box_grid_active");
              }else if ($(this).hasClass("stepbox_funko_pop")) {
                $(document).find(".steps_box_grid_funko_pop").addClass("steps_box_grid_active");
              }else if ($(this).hasClass("stepbox_photo_and_flats_larger_than")) {
                $(document).find(".steps_box_grid_photo_and_flats_larger_than").addClass("steps_box_grid_active");
              }
          
              if ($(document).find('.steps_box_grid').hasClass("steps_box_grid_active")) {
                $(document).find(".send_in_type_select_option_steps_warpper").addClass("send_in_type_select_option_steps_active");
              }else{
                $(document).find(".send_in_type_select_option_steps_warpper").removeClass("send_in_type_select_option_steps_active");
              }
          
              $(document).find('ul#signet_order_type_items li').removeClass('signet_cast_price');
              $(this).addClass('signet_cast_price');

              var thsPro = $.trim($(this).attr('data-name'));
              var inputVal = $.trim($(this).attr('data-title'));
              var splitValue = inputVal.split('-');
              var inputVal = splitValue[0];
              $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
              $(document).find("#itg_properties_data").append(`<input type="hidden" name="${thsPro}" value="${inputVal}">`);

              $(document).find('.select_ink_color_wrapper').removeClass('itg_disable_items');
              cal_price(addprice = 0);
              $(document).find('#valid_btn_submit').removeClass('btn_check_status');
              updateSealVisibility();
        });

        /*Start-Trading-Cards */
         $(document).on('click','ul.steps_box_grid_tranding_cards .step_first_trade',function() {
               $(document).find('.step_first_trade').removeClass('trade_active_first');
               $(this).addClass('trade_active_first');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               var thsPro = 'properties[Slab-Crack]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               $(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_2').show();
               if(thsPrice != 0){
                  $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                  $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
                 $(this).closest('li').find('.steps_box_grid_item_price_added').show();
               }else{
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
               }
               cal_price(addprice = 0);
         });
         $(document).on('click','ul.steps_box_grid_tranding_cards .step_second_trade',function() {
               $(document).find('.step_second_trade').removeClass('trade_active_second');
               $(this).addClass('trade_active_second');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               var thsPro = 'properties[CGC Encapsulation]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               if(thsPrice != 0){
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
                 $(this).closest('li').find('.steps_box_grid_item_price_added').show();
                 $(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3').show();
               }else{
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(document).find(`#itg_properties_data input[name="properties[CGC Pressing]"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
                 $(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3').hide();
                 $(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3').attr('data-cprice','0');
                 $(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3 .step_third_trade').removeClass('trade_active_third');
               }
               cal_price(addprice = 0);
               updateSealVisibility();
         });
         $(document).on('click','ul.steps_box_grid_tranding_cards .step_third_trade',function() {
               $(document).find('.step_third_trade').removeClass('trade_active_third');
               $(this).addClass('trade_active_third');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               var thsPro = 'properties[CGC Pressing]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               if(thsPrice != 0){
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
                 $(this).closest('li').find('.steps_box_grid_item_price_added').show();
               }else{
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
               }
               cal_price(addprice = 0);
               //$(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3').show();
         });
        /*End-Trading-Cards */

        /*Start-Comix-book-or-magazine*/
          $(document).on('click','ul.steps_box_grid_comix_book_or_magazine .step_first_book',function() {
               $(document).find('.step_first_book').removeClass('book_active_first');
               $(this).addClass('book_active_first');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               $(document).find('ul.steps_box_grid_comix_book_or_magazine li.steps_box_grid_item_step_2').show();
               var thsPro = 'properties[Slab-Crack]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               if(thsPrice != 0){
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
                 $(this).closest('li').find('.steps_box_grid_item_price_added').show();
               }else{
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
               }
               cal_price(addprice = 0);
         });
         $(document).on('click','ul.steps_box_grid_comix_book_or_magazine .step_second_book',function() {
               $(document).find('.step_second_book').removeClass('book_active_second');
               $(this).addClass('book_active_second');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               var thsPro = 'properties[CGC Encapsulation]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               if(thsPrice != 0){
                  $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                  $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`)
                  $(this).closest('li').find('.steps_box_grid_item_price_added').show();
                  $(document).find('ul.steps_box_grid_comix_book_or_magazine li.steps_box_grid_item_step_3').show();
               }else{
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(document).find(`#itg_properties_data input[name="properties[CGC Pressing]"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
                 $(document).find('ul.steps_box_grid_comix_book_or_magazine li.steps_box_grid_item_step_3').hide();
                 $(document).find('ul.steps_box_grid_comix_book_or_magazine li.steps_box_grid_item_step_3').attr('data-cprice','0');
                 $(document).find('ul.steps_box_grid_comix_book_or_magazine li.steps_box_grid_item_step_3 .step_third_book').removeClass('book_active_third');
               }
               cal_price(addprice = 0);
               updateSealVisibility();
         });
         $(document).on('click','ul.steps_box_grid_comix_book_or_magazine .step_third_book',function() {
               $(document).find('.step_third_book').removeClass('book_active_third');
               $(this).addClass('book_active_third');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               var thsPro = 'properties[CGC Pressing]';
               var inputVal = $.trim($(this).closest('li').find('.steps_box_grid_item_price_added').attr('data-title'));
               if(thsPrice != 0){
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
                 $(this).closest('li').find('.steps_box_grid_item_price_added').show();
               }else{
                 $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
                 $(this).closest('li').find('.steps_box_grid_item_price_added').hide();
               }
               cal_price(addprice = 0);
               //$(document).find('ul.steps_box_grid_tranding_cards li.steps_box_grid_item_step_3').show();
         });
        /*End-Comix-book-or-magazine*/
       
        /* Start-Funko-POP */
          $(document).on('click','ul.itg_sending_steps_box_grid_funko_pop button',function() {
               $(document).find('ul.itg_sending_steps_box_grid_funko_pop button').removeClass('personal_active');
               $(this).addClass('personal_active');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               $(this).closest('li').find('.step_box_disclaimer').show();
               var thsPro = 'properties[Funko Pop]';
               var inputVal = $.trim($(this).attr('data-boxname'));
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
               cal_price(addprice = 0);
          });
        /* End-Funko-POP */
       
        /* Start-Photo-and-flats-larger */
          $(document).on('click','ul.steps_box_grid_photo_and_flats_larger_than button',function() {
               $(document).find('ul.steps_box_grid_photo_and_flats_larger_than button').removeClass('personal_active');
               $(this).addClass('personal_active');
               var thsPrice = $(this).attr('data-boxprice');
               $(this).closest('li').attr('data-cprice',thsPrice);
               $(this).closest('li').find('.step_box_disclaimer').show();
               var thsPro = 'properties[Photo Flat]';
               var inputVal = $.trim($(this).attr('data-boxname'));
               $(document).find(`#itg_properties_data input[name="${thsPro}"]`).remove();
               $(document).find("#itg_properties_data").append(`<input type="hidden" class="personal_pro" name="${thsPro}" value="${inputVal}">`);
               cal_price(addprice = 0);
          });
        /* End-Photo-and-flats-larger */
         
     }
   //End-select-item-signet_order_type

   if($(document).find(".order_type_wrapper").length > 0) {
      $(document).on("click", ".order_type_heading_head", function () {
          $(".order_type_list_label").toggleClass("drop_down_active");
      });
      $(document).on("click", ".order_type_list_label", function () {
          addons_check();
          defult_cal();
          empty_sel();
          $(document).find('#heading_cast_price').hide();
          $(document).find('#heading_cast_price').attr('data-set','0');
          $(document).find('.order_type_list_label').removeClass('check_order_type');
          $(document).find(".order_type_list_label").removeClass("drop_down_active");
          $(document).find(".order_type_heading").text($(this).text());
          $(this).addClass('check_order_type');
        
          $(".additional_charge_add_on #additional_charge_checkbox").prop("checked",false);
        
          let typeLabelValue = $(this).attr("type-label");
          let orderType = $.trim($(this).attr('type-name'));
          $(document).find(".order_type_content_wrapper").each(function () {
              let typeContentValue = $(this).attr("product-content");
              $(this).toggleClass("order_type_content_active", typeLabelValue === typeContentValue);
          });
          $(".provide_a_detailed_description_head").toggleClass("provide_a_detailed_description_active",typeLabelValue === 'preorder_spi' || typeLabelValue === 'preorder_acp');

          if(typeLabelValue == undefined)
            $(document).find(".additional_charge_add_on").removeClass("show") ;
        
          if(typeLabelValue == 'preorder_ofs') {
            $(document).find('.autograph_add_ons_wrapper').removeClass('itg_autograph_add_ons_wrapper');
            $(document).find(".additional_charge_add_on").removeClass("show") ;
            signet_items();
          }
          if(typeLabelValue == 'preorder_acp') {
            $(document).find('#heading_cast_price').show();
            $(document).find('#heading_cast_price').attr('data-set','1');
            $(document).find('.autograph_add_ons_wrapper').removeClass('itg_autograph_add_ons_wrapper');
            $(document).find('#field_name_order_number').val('');

            $(document).find(".additional_charge_add_on.checkbox-field-wrapper.sending_in_personal_product").removeClass("show") ;
            $(document).find(".additional_charge_add_on.checkbox-field-wrapper.add_to_cast_item ").addClass("show") ;
            
            signet_existing_order();
            cal_price(addprice = 0);
          }
          if(typeLabelValue == 'preorder_spi'){
            $(document).find('.autograph_add_ons_wrapper').removeClass('itg_autograph_add_ons_wrapper');

            $(document).find(".additional_charge_add_on.checkbox-field-wrapper.sending_in_personal_product").addClass("show") ;
            $(document).find(".additional_charge_add_on.checkbox-field-wrapper.add_to_cast_item").removeClass("show") ;
            
            signet_order_type();
          }

          $(document).find(`#itg_properties_data input[name="properties[Choose Order]"]`).remove();
          if(orderType){
            var thsPro = 'properties[Choose Order]';
            $(document).find("#itg_properties_data").append(`<input type="hidden" name="${thsPro}" value="${orderType}">`);
          }

          updateSealVisibility();

      });
   }

  
  // additional charge add on js

   $(".additional_charge_add_on").find("#additional_charge_checkbox").change(function() {
    
    if ($(this).is(":checked")) {

          const dataAddOnCharge = Number($(this).attr("data-addons"));

          $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[Add on Upcharge]" value="$${dataAddOnCharge.toFixed(2)}">`) ; 
      
          let prevPrice = Number($(".price_container_head .itg_custom_price").attr("data-orignalprice"));
          let newPrice = (prevPrice + dataAddOnCharge).toFixed(2); // Ensures two decimal places
  
          $(".price_container_head .itg_custom_price").attr("data-orignalprice", newPrice);      
          $(".price_container_head .itg_custom_price").html(`$${newPrice}`);
          
      } else {
          const dataAddOnCharge = Number($(this).attr("data-addons"));
      
          $(document).find("#itg_properties_data input[name='properties[Add on Upcharge]']").remove(); 
      
          let prevPrice = Number($(".price_container_head .itg_custom_price").attr("data-orignalprice"));
          let originalPrice = (prevPrice - dataAddOnCharge).toFixed(2); // Ensures two decimal places
  
          $(".price_container_head .itg_custom_price").attr("data-orignalprice", originalPrice);
          $(".price_container_head .itg_custom_price").html(`$${originalPrice}`);
      
      }
  });

  // additional charge add on js
  
   $(document).on("click", "#valid_btn_submit", function () {
        // ⚠ Wipe every previous mark before re-checking. Each field clears itself when touched,
        // but a customer can fix one field and click again while an EARLIER field is still red —
        // the checks stop at the first failure, so that stale mark would otherwise sit there
        // pointing at something already correct.
        sgpClearAllInvalid();
        // Every failed check appends here instead of returning, so one submit reports
        // everything that is wrong rather than the first thing it happens to reach.
        var sgpProblems = [];

        var checkboxStatus = 1;
        var category1Checked = $('#character_name_checkbox:checked').length > 0;
        var category2Checked = $('#personalization_details_checkbox:checked').length > 0;
        var category3Checked = $('#quote_checkbox:checked').length > 0;
        var remarqueChecked  = $('#remarque_checkbox:checked').length > 0;
        var headshotChecked  = $('#headshot_checkbox:checked').length > 0;
        var bustChecked      = $('#bust_checkbox:checked').length > 0;
        var fullBodyChecked  = $('#full_body_checkbox:checked').length > 0;
        var customAddon1Checked = $('#custom_addon_1_checkbox:checked').length > 0;
        var customAddon2Checked = $('#custom_addon_2_checkbox:checked').length > 0;
        var customAddon3Checked = $('#custom_addon_3_checkbox:checked').length > 0;

        var category4Checked = $(".provide_a_detailed_description_head.provide_a_detailed_description_active").length > 0  ;

        if(category4Checked == true){
          let detailedDescription =  $("#field_detailed_description").val() ;
            if(detailedDescription){
              checkboxStatus = 1 ;
            }
            else{
                checkboxStatus = 0 ;
                sgpProblems.push(['#field_detailed_description', 300]);
              }
          }

         // -----------------------ink color-------------------------
        // ⛔ SCOPED TO THE ACTIVE FLOW. This used to be a bare
        // `document.querySelector('.active-link-color')` — a whole-document search — while the
        // error it raises has always been scoped to `.order_type_content_active`. Detect
        // globally, report locally: the asymmetry is the bug.
        //
        // OFS, SPI and ACP all keep their ink pickers in the DOM at once and are shown/hidden by
        // toggling `.order_type_content_active`, and the class is added by a global handler
        // (`$(document).on("click", ".select_ink_color_label"…)`) with no flow scoping. So a
        // colour chosen in ANY flow — including a hidden one — satisfied the check for EVERY
        // flow: pick a colour in SPI, switch to OFS, leave it blank, and add-to-cart went
        // through with no Ink Color property on the line.
        //
        // Pre-existing since the Phase 2.1 revamp (39bfde9 / 00def1e), not from the 2026-08-23
        // validation work — that only restyled the failure from a navy glow to crimson.
        // Found by clicking through the OFS flow on the backup theme, 2026-08-27.
        var inkColorActive = document.querySelector('.order_type_content_active .active-link-color');

        if (inkColorActive) {
        } else {
          // ⚠ This one already marked itself — but with a NAVY glow (#1f4f67), the same colour as
          // the page's own headings and borders, so it read as emphasis rather than as an error.
          // Now the same crimson every other failed field gets, so one colour means one thing.
          // ⛔ Targets the WRAPPER, not an input, which is why the helper detects a non-field and
          // switches to an outline — a border tint has nothing to tint here.
          checkboxStatus = 0;
          sgpProblems.push([
            '.order_type_content_active .itg-custom-link-wrapper .custom_select_option_wrapper',
            350,
            'Please choose an ink colour before adding to cart.'
          ]);
        }


        // -----------------------ink color-------------------------

     

        if(category1Checked == true){
          var character_name = $(document).find('#character_name').val();
          if(character_name){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            sgpProblems.push(['#character_name', 300]);
          }
        }
       if(category2Checked == true){
           var personalization_details = $(document).find('#personalization_details').val();
           if(personalization_details){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            sgpProblems.push(['#personalization_details', 250]);
          }
        }
       if(category3Checked == true){
          var quote = $(document).find('#quote').val();
          if(quote){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            sgpProblems.push(['#quote', 300]);
          }
        }
       if(remarqueChecked == true){
          var remarque = $(document).find('#remarque').val();
          if(remarque){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            sgpProblems.push(['#remarque', 300]);
          }
        }
       if(headshotChecked == true){
          var headshot = $(document).find('#headshot').val();
          if(headshot){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            sgpProblems.push(['#headshot', 300]);
          }
        }
       if(bustChecked == true){
          var bust = $(document).find('#bust').val();
          if(bust){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            sgpProblems.push(['#bust', 300]);
          }
        }
       if(fullBodyChecked == true){
          var full_body = $(document).find('#full_body').val();
          if(full_body){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            sgpProblems.push(['#full_body', 300]);
          }
        }
       if(customAddon1Checked == true){
          var custom_addon_1 = $(document).find('#custom_addon_1').val();
          if(custom_addon_1){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            sgpProblems.push(['#custom_addon_1', 300]);
          }
        }
       if(customAddon2Checked == true){
          var custom_addon_2 = $(document).find('#custom_addon_2').val();
          if(custom_addon_2){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            sgpProblems.push(['#custom_addon_2', 300]);
          }
        }
       if(customAddon3Checked == true){
          var custom_addon_3 = $(document).find('#custom_addon_3').val();
          if(custom_addon_3){
            checkboxStatus = 1;
          }else{
            checkboxStatus = 0;
            sgpProblems.push(['#custom_addon_3', 300]);
          }
        }

     // ⛔ THE ACKNOWLEDGEMENT CHECK MOVED OUT OF THE GATE BELOW. It used to live inside
     // `if(checkboxStatus == 1)`, so whenever any field had already failed it never ran — and
     // an unticked box could not be reported until every other problem was fixed first. That
     // was half of why the form surfaced one issue at a time.
     if (!$(document).find('#tmp-28_checkbox').is(':checked')) {
       sgpProblems.push(['.add_ons_acknowledge_head', 250,
         'Please confirm the details above are correct before adding to cart.']);
     }

     // ⭐ ONE report for everything wrong, rather than a discovery game. Marks every problem,
     // then scrolls to the topmost one so the customer starts at the first thing to fix.
     if (sgpProblems.length) return sgpReportProblems(sgpProblems);

     if(checkboxStatus == 1){
        if($(document).find('#tmp-28_checkbox').is(':checked')) {
             $(document).find('.addLoader').addClass('it_loading');
          
             var allpro_price = $(document).find('.itg_custom_price').attr('data-orignalprice');
             // ⛔ DROP-OFFS MUST NOT WRITE _Total Price.
             //
             // `_Total Price` is the page's running total, and main-cart-items.liquid
             // renders it IN PLACE OF Shopify's own line price (:102, :169, :254, :482).
             // That works for a pre-order, where every line in the bundle came from a
             // customer selection and so passed through this calculation.
             //
             // The drop-off handling fee did not. It is pushed unconditionally below —
             // it is the one charge nobody selects — so it is absent from the running
             // total. Writing that total here showed a $275 order as $250 in the cart,
             // under a "+$45.00 in add-ons" note that reconciled to neither number.
             // Only the display was wrong; the fan was charged correctly.
             //
             // Folding the fee into the base was tried and is WRONG: the fee has two
             // rates and the large one is chosen from the selected tier (see the
             // `isLarge` test below), so any fixed base misreports large items by the
             // difference.
             //
             // Omitting the property makes all three cart render paths fall through to
             // `item.original_price` / `item.original_line_price` — Shopify's real
             // numbers — and cart.js's add-ons note then reconciles exactly.
             //
             // ⚠ PRE-ORDERS ARE UNAFFECTED. `#dropoff_fee_block` is rendered only by
             // signet-dropoff-gate.liquid, which only the drop-off fork calls. On a
             // pre-order page that element does not exist, so this reads exactly as
             // `if (allpro_price)` did before.
             if(allpro_price && !document.getElementById('dropoff_fee_block')){
               $(document).find("#itg_properties_data").append(`<input type="hidden" name="properties[_Total Price]" value="${allpro_price}">`);
             }
          
             var random_number = $(document).find('#random_number').val();
             var itemsDataNew = {};
             itemsDataNew['items'] = [];
          
             var photo_info = $(document).find('#choose_photo').val();
             if(photo_info){
               
                   var photo_infoId = $(document).find('#choose_photo').attr('upload-id');
                   var photo_infoText = getPhotoIdValue($(document).find(".photo_id_button"));
                   var photo_upload = $(document).find('#choose_photo').attr('data-imgfinal');

                   var photosizePrice = $(document).find('li.select_photo_item.select_photo_item_active').attr('size-id');
               
                   itemsDataNew['items'].push({
                      id: photo_infoId,
                      quantity: 1,
                      properties: {
                         "Photo ID": photo_infoText,
                         "_Upload Photo":photo_upload,
                         "_Rno":random_number,
                      }
                  });

                  itemsDataNew['items'].push({
                        id: photosizePrice,
                        quantity: 1,
                        properties: {
                          "Photo ID": photo_infoText,
                          "_Rno":random_number,
                        }
                    });
               
             }else{
                var photosizePrice = $(document).find('li.select_photo_item.select_photo_item_active').attr('size-id');
                if(photosizePrice){
                     var photo_infoText = getPhotoIdValue($(document).find(".photo_id_button"));
                     itemsDataNew['items'].push({
                        id: photosizePrice,
                        quantity: 1,
                        properties: {
                          "Photo ID": photo_infoText,
                          "_Rno":random_number,
                        }
                    });
                }
             }
             var funkoId = $(document).find('li.funko_pop_grid_item.funko_pop_grid_item_active').attr('data-funkoid');
             if(funkoId){
                 itemsDataNew['items'].push({
                    id: funkoId,
                    quantity: 1,
                    properties: {
                      "_Rno":random_number,
                    }
                 });
             }

             var signet_cast_id = $(document).find('.signet_cast_price').attr('data-itemid');
             if(signet_cast_id){
                itemsDataNew['items'].push({
                    id: signet_cast_id,
                    quantity: 1,
                    properties: {
                     "_Rno":random_number,
                    }
                 });
             }
             $(document).find("ul.steps_box_grid_tranding_cards li").each(function() {
                var trade_active_first = $(this).find('.trade_active_first').attr('data-tradid');
                var trade_active_second = $(this).find('.trade_active_second').attr('data-tradid');
                if(trade_active_first){
                  itemsDataNew['items'].push({
                     id: trade_active_first,
                     quantity: 1,
                     properties: {
                       "_Rno":random_number,
                     }
                 });
                }
                if(trade_active_second){
                  itemsDataNew['items'].push({
                     id: trade_active_second,
                     quantity: 1,
                     properties: {
                        "_Rno":random_number,
                      }
                 });
                }
             });
             $(document).find("ul.steps_box_grid_photo_and_flats_larger_than li").each(function() {
                var personal_active = $(this).find('.personal_active').attr('data-pf');
                if(personal_active){
                    itemsDataNew['items'].push({
                      id: personal_active,
                      quantity: 1,
                      properties: {
                        "_Rno":random_number,
                      }
                   });
                }
             });
             $(document).find("ul.itg_sending_steps_box_grid_funko_pop li").each(function() {
                var personal_active1 = $(this).find('.personal_active').attr('data-fp');
                if(personal_active1){
                  itemsDataNew['items'].push({
                    id: personal_active1,
                    quantity: 1,
                    properties: {
                      "_Rno":random_number,
                    }
                 });
                }
             });

             $(document).find("ul.steps_box_grid_comix_book_or_magazine li").each(function() {
                 var book_active_first = $(this).find('.book_active_first').attr('data-comixslab');
                 var book_active_second = $(this).find('.book_active_second').attr('data-comixscgc')
                 var book_active_third = $(this).find('.book_active_third').attr('data-comixspre');
                   if(book_active_first){
                     itemsDataNew['items'].push({
                       id: book_active_first,
                       quantity: 1,
                        properties: {
                           "_Rno":random_number,
                        }
                      });
                   }
                   if(book_active_second){
                      itemsDataNew['items'].push({
                         id: book_active_second,
                         quantity: 1,
                          properties: {
                           "_Rno":random_number,
                          }
                     });
                   }
                   if(book_active_third){
                      itemsDataNew['items'].push({
                         id: book_active_third,
                         quantity: 1,
                         properties: {
                           "_Rno":random_number,
                         }
                     });
                   } 
             });

             var add_castePiece = $(document).find('#heading_cast_price').attr('data-set');
             if(add_castePiece == 1){
                   var castePieceId = $(document).find('#heading_cast_price').attr('data-addcastid');
                   var castePieceText = $(document).find('#field_name_order_number').val();
                   if(castePieceId){
                      itemsDataNew['items'].push({
                         id: castePieceId,
                         quantity: 1,
                         properties: {
                          "_Rno":random_number,
                         }
                     });
                   } 
             }
             var caste_reorder = $(document).find('.check_caste_piece').attr('data-itemid');
             if(caste_reorder){
                  itemsDataNew['items'].push({
                     id: caste_reorder,
                     quantity: 1,
                     properties: {
                      "_Rno":random_number,
                     }
                 });
             }
             $(document).find("ul#funko_pop_flat li").each(function() {
                var steps_box_button_active = $(this).find('.steps_box_button_active').attr('data-fpcast');
                if(steps_box_button_active){
                    itemsDataNew['items'].push({
                       id: steps_box_button_active,
                       quantity: 1,
                       properties: {
                        "_Rno":random_number,
                      }
                   });
                }
             });
             var character_name = $(document).find('#character_name').val();
             if(character_name){
                 var chrId = $(document).find('#character_name').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: chrId,
                     quantity: 1,
                     properties: {
                        "Character Name": character_name,
                         "_Rno":random_number,
                      }
                 });
             }
            
             var personal_detail = $(document).find('#personalization_details').val();
             if(personal_detail){
                 var persId = $(document).find('#personalization_details').attr('data-chr');
                 itemsDataNew['items'].push({
                    id: persId,
                    quantity: 1,
                    properties: {
                      "Personalization Details": personal_detail,
                      "_Rno":random_number,
                    }
                 });
             }
             var quote_detail = $(document).find('#quote').val();
             if(quote_detail){
                 var qoutId = $(document).find('#quote').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: qoutId,
                     quantity: 1,
                     properties: {
                        "Quote": quote_detail,
                        "_Rno":random_number,
                      }
                 });
             }
             var remarque_detail = $(document).find('#remarque').val();
             if(remarque_detail){
                 var remarqueId = $(document).find('#remarque').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: remarqueId,
                     quantity: 1,
                     properties: {
                        "Remarque": remarque_detail,
                        "_Rno":random_number,
                      }
                 });
             }
             var headshot_detail = $(document).find('#headshot').val();
             if(headshot_detail){
                 var headshotId = $(document).find('#headshot').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: headshotId,
                     quantity: 1,
                     properties: {
                        "Headshot": headshot_detail,
                        "_Rno":random_number,
                      }
                 });
             }
             var bust_detail = $(document).find('#bust').val();
             if(bust_detail){
                 var bustId = $(document).find('#bust').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: bustId,
                     quantity: 1,
                     properties: {
                        "Bust": bust_detail,
                        "_Rno":random_number,
                      }
                 });
             }
             var full_body_detail = $(document).find('#full_body').val();
             if(full_body_detail){
                 var fullBodyId = $(document).find('#full_body').attr('data-chr');
                 itemsDataNew['items'].push({
                     id: fullBodyId,
                     quantity: 1,
                     properties: {
                        "Full Body": full_body_detail,
                        "_Rno":random_number,
                      }
                 });
             }
             ['#custom_addon_1','#custom_addon_2','#custom_addon_3'].forEach(function(sel){
               var $el = $(document).find(sel);
               var val = $el.val();
               if(val){
                 var addonId    = $el.attr('data-chr');
                 var addonLabel = $el.attr('data-label') || sel.replace('#','');
                 var addonProps = { "_Rno": random_number };
                 addonProps[addonLabel] = val;
                 itemsDataNew['items'].push({ id: addonId, quantity: 1, properties: addonProps });
               }
             });


          // additional charge add on js

          let addVariantId = $(".additional_charge_add_on.show #additional_charge_checkbox").attr("data-variant-id") ;
          let add_on_upcharge_price = "$" + Number($(".additional_charge_add_on.show #additional_charge_checkbox").attr("data-addons")).toFixed(2) ;

          if($(".additional_charge_add_on").find("#additional_charge_checkbox").is(":checked")){

               if(addVariantId){
                 itemsDataNew['items'].push({
                     id: addVariantId,
                     quantity: 1,
                     properties: {
                       "Add On Upcharge": add_on_upcharge_price,
                        "_Rno":random_number,
                      }
                 });
              }
          }

          // additional charge add on js

        // const inputProps = {};
        // const _Rno = document.querySelector('#random_number')?.value || '';
        // inputProps._Rno = _Rno;
        
        // document.querySelectorAll('.add_on__head .add_on__head_fields').forEach(f => {
        //   const checkbox = f.querySelector('input[type="checkbox"]');
        //   const input = f.querySelector('input[type="text"]');
        //   if (checkbox?.checked && input?.value.trim()) {
        //     const match = input.dataset.pro?.match(/properties\[(.+?)\]/);
        //     if (match) {
        //       const key = match[1];
        //       inputProps[key] = input.value.trim();
        //     }
        //   }
        // });
        
          // JSA Authentication — separate bundle line item
          var jsaActiveTier = $(document).find('.jsa_tier_item.jsa_tier_active');
          if (jsaActiveTier.length > 0) {
            var jsaVid = jsaActiveTier.attr('data-jsa-variantid');
            if (jsaVid) {
              var jsaLabel = jsaActiveTier.attr('data-jsa-type') === 'witness' ? 'Witness Authentication' : 'Letter of Authenticity';
              itemsDataNew['items'].push({
                id: parseInt(jsaVid),
                quantity: 1,
                properties: {
                  "JSA Authentication": jsaLabel,
                  "_Rno": random_number
                }
              });
            }
          }

          // ── Onsite drop-off handling fee ──────────────────────────────────
          //
          // ⛔ THE ONLY UNCONDITIONAL LINE IN THIS CART. Everything above is
          // pushed because the customer selected something; the handling fee is
          // not optional and nobody selects it. Without this the fee product
          // exists in Shopify, reads as configured in the portal, and is never
          // charged — silent lost revenue on every drop-off, with nothing
          // erroring anywhere.
          //
          // The variant ids come from the shared "Drop-Off Handling" product via
          // the shop metafield, rendered into data attributes by
          // signet-dropoff-gate.liquid. That snippet only renders in drop-off
          // mode, so this block is inert on a pre-order — the element simply
          // isn't there.
          //
          // Large/prop rate when the chosen item type says so, standard
          // otherwise. `_Rno` ties the fee to the same bundle as the signing
          // line it belongs to, so Order Viewer groups them like every other
          // add-on.
          var dropoffFeeBlock = document.getElementById('dropoff_fee_block');
          if (dropoffFeeBlock) {
            var feeStd   = dropoffFeeBlock.getAttribute('data-dropoff-fee-standard');
            var feeLarge = dropoffFeeBlock.getAttribute('data-dropoff-fee-large');
            var chosen   = ($(document).find('li.tier_item_active').text() || '').toLowerCase();
            var isLarge  = /prop|large|27x40|oversize/.test(chosen);
            var feeId    = (isLarge && feeLarge) ? feeLarge : feeStd;
            if (feeId) {
              itemsDataNew['items'].push({
                id: feeId,
                quantity: 1,
                properties: { "_Rno": random_number }
              });
            }
          }

        const bundleItems = JSON.stringify(itemsDataNew);
// ------- new code by (R) start---------//
          const form = document.querySelector(
          'form[data-type="add-to-cart-form"]'
        );
        const formData = new FormData(form);
        const container = document.querySelector("#itg_properties_data");

        const formProps = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+?)\]$/);
          if (match) formProps[match[1]] = value;
        }

        const allBundleProps = {};
        itemsDataNew.items.forEach((item) => {
          Object.entries(item.properties || {}).forEach(([key, value]) => {
            allBundleProps[key] = value;
          });
        });

         const getInfo = () => {
            const ua = navigator.userAgent;
            const platform = navigator.platform.toLowerCase();
          
            const os = /win/.test(platform)
              ? "Windows"
              : /mac/.test(platform)
              ? "macOS"
              : /linux/.test(platform)
              ? "Linux"
              : /android/i.test(ua)
              ? "Android"
              : /iphone|ipad|ipod/i.test(ua)
              ? "iOS"
              : "Unknown";
          
            const osVersionMatch = ua.match(/(Windows NT|Mac OS X|Android|CPU (iPhone )?OS)\s([0-9_\.]+)/i);
            const osVersion = osVersionMatch ? osVersionMatch[3].replace(/_/g, ".") : "Unknown";
          
            const browserMatch = ua.match(/(Edg|Chrome|CriOS|Firefox|Safari|MSIE|Trident)\/?\s?([0-9.]+)/i);
            let browser = "Unknown", browserVersion = "Unknown";
          
            if (browserMatch) {
              const name = browserMatch[1];
              browserVersion = browserMatch[2];
              if (/edg/i.test(name)) browser = "Edge";
              else if (/crios|chrome/i.test(name)) browser = "Chrome";
              else if (/firefox/i.test(name)) browser = "Firefox";
              else if (/safari/i.test(name)) browser = "Safari";
              else if (/msie|trident/i.test(name)) browser = "IE";
            }
          
            return {
              os,
              osVersion,
              browser,
              browserVersion
            };
          };
           const userInfo = getInfo(); 

        Object.entries(allBundleProps).forEach(([key, value]) => {
          const existingInput = container.querySelector(
            `input[name="properties[${key}]"]`
          );

          if (existingInput) {
            if (!existingInput.value.trim() || existingInput.value !== value) {
              existingInput.value = value;
              existingInput.classList.add("corrected-from-bundle");
            }
            

            if (container && userInfo) {
              let existingInput = container.querySelector(`input[name="properties[_device]"]`);
              const deviceInfo = `${userInfo.os} (${userInfo.osVersion}) /${userInfo.browser} (${userInfo.browserVersion})`;            
              if (!existingInput) {
                const newInput = document.createElement("input");
                newInput.type = "hidden";
                newInput.name = "properties[_device]";
                newInput.value = deviceInfo;
                container.appendChild(newInput);
              } else if (existingInput.value !== deviceInfo) {
                existingInput.value = deviceInfo; 
              }
            }
          } else {
            const newInput = document.createElement("input");
            newInput.type = "hidden";
            newInput.name = `properties[${key}]`;
            newInput.value = value;
            container.appendChild(newInput);

          }
        });
// ------- new code by (R) End---------//
          
             fetch('/cart/add.js', {  
                  method: 'POST',  
                  headers: {
                   'Content-Type': 'application/json',
                  },
                  body: bundleItems,
              }).then(response => {  
                  if (!response.ok) { }  
                  return response.json();  
              }).then(data => { 
               
                setTimeout(function() {
                    $(document).find('.itg_orignal_btn').trigger('click');
                    $(document).find('.addLoader').removeClass('it_loading');
                  }, 1000);
              }).catch(error => {
                  //alert('There was a problem with the fetch operation:', error);
              });

        }else {
          // ⛔ WAS a browser alert(). An alert names the problem and then vanishes, leaving the
          // page exactly as it was — so you are told something is wrong and given no help
          // finding it. Operator: "same with the check acknowledgement — make the little box
          // turn red?"
          // ⚠ UNREACHABLE, and kept only as a backstop. The acknowledgement is now checked
          // above alongside every other field, and a failure returns before this gate — so by
          // the time execution is inside `if (checked)`, the box is ticked by definition.
          // Left in place because the outer `if (checkboxStatus == 1)` is not ours to remove
          // safely, and a silent no-op branch is worse than one that says why it exists.
          return false;
        }
     }

   });

   // ---- JSA Authentication ----
   $(document).on('click', '.jsa_no_btn', function() {
     $(document).find('.jsa_no_btn').addClass('jsa_toggle_active');
     $(document).find('.jsa_yes_btn').removeClass('jsa_toggle_active');
     $(document).find('.jsa_options_head').hide();
     $(document).find('.jsa_tier_item').removeClass('jsa_tier_active');
     $(document).find('.jsa_witness_placement_head').hide();
     $(document).find('.jsa_placement_btn').removeClass('jsa_placement_active');
     $(document).find('#jsa_price_checkbox').prop('checked', false).attr('data-addons', '0');
     $(document).find(`#itg_properties_data input[name="properties[JSA Authentication]"]`).remove();
     $(document).find(`#itg_properties_data input[name="properties[JSA Sticker Placement]"]`).remove();
     cal_price(0);
     updateSealVisibility();
   });

   $(document).on('click', '.jsa_yes_btn', function() {
     $(document).find('.jsa_yes_btn').addClass('jsa_toggle_active');
     $(document).find('.jsa_no_btn').removeClass('jsa_toggle_active');
     $(document).find('.jsa_options_head').show();
     // Seal is mutually exclusive with JSA — hide and reset it
     $(document).find('.signet_seal_wrapper').hide();
     $(document).find('.seal_optin_head').hide();
     $(document).find('.seal_placement_head').hide();
     $(document).find('.seal_no_btn').addClass('seal_toggle_active');
     $(document).find('.seal_yes_btn').removeClass('seal_toggle_active');
     $(document).find('.seal_placement_btn').removeClass('seal_placement_active');
     $(document).find(`#itg_properties_data input[name="properties[Signet Seal]"]`).remove();
   });

   $(document).on('click', '.jsa_tier_item', function() {
     $(document).find('.jsa_tier_item').removeClass('jsa_tier_active');
     $(this).addClass('jsa_tier_active');
     var jsaType = $(this).attr('data-jsa-type');
     var jsaPrice = $(this).attr('data-jsa-price');
     var jsaLabel = jsaType === 'witness' ? 'Witness Authentication' : 'Letter of Authenticity';
     $(document).find('#jsa_price_checkbox').attr('data-addons', jsaPrice).prop('checked', true);
     $(document).find(`#itg_properties_data input[name="properties[JSA Authentication]"]`).remove();
     $(document).find('#itg_properties_data').append(`<input type="hidden" name="properties[JSA Authentication]" value="${jsaLabel}">`);
     if (jsaType === 'witness') {
       $(document).find('.jsa_witness_placement_head').show();
     } else {
       $(document).find('.jsa_witness_placement_head').hide();
       $(document).find('.jsa_placement_btn').removeClass('jsa_placement_active');
       $(document).find(`#itg_properties_data input[name="properties[JSA Sticker Placement]"]`).remove();
     }
     cal_price(0);
   });

   $(document).on('click', '.jsa_placement_btn', function() {
     $(document).find('.jsa_placement_btn').removeClass('jsa_placement_active');
     $(this).addClass('jsa_placement_active');
     var placement = $(this).attr('data-placement');
     $(document).find(`#itg_properties_data input[name="properties[JSA Sticker Placement]"]`).remove();
     $(document).find('#itg_properties_data').append(`<input type="hidden" name="properties[JSA Sticker Placement]" value="${placement}">`);
   });

   // ---- Signet Seal + JSA visibility ----
   function updateSealVisibility() {
     var isSpiActive = $(document).find('.order_type_content_wrapper[product-content="preorder_spi"]').hasClass('order_type_content_active');
     var isTcOrComic = $(document).find('.steps_box_grid_tranding_cards').hasClass('steps_box_grid_active') ||
                       $(document).find('.steps_box_grid_comix_book_or_magazine').hasClass('steps_box_grid_active');
     var hasCgc = false;
     $(document).find('.trade_active_second, .book_active_second').each(function() {
       if (parseFloat($(this).attr('data-boxprice')) > 0) hasCgc = true;
     });

     // SPI trading card or comic with CGC — hide both JSA and Seal entirely
     if (isSpiActive && isTcOrComic && hasCgc) {
       $(document).find('.jsa_authentication_wrapper').hide();
       $(document).find('.jsa_no_btn').addClass('jsa_toggle_active');
       $(document).find('.jsa_yes_btn').removeClass('jsa_toggle_active');
       $(document).find('.jsa_options_head').hide();
       $(document).find('.jsa_tier_item').removeClass('jsa_tier_active');
       $(document).find('.jsa_witness_placement_head').hide();
       $(document).find('.jsa_placement_btn').removeClass('jsa_placement_active');
       $(document).find('#jsa_price_checkbox').prop('checked', false).attr('data-addons', '0');
       $(document).find(`#itg_properties_data input[name="properties[JSA Authentication]"]`).remove();
       $(document).find(`#itg_properties_data input[name="properties[JSA Sticker Placement]"]`).remove();
       $(document).find('.signet_seal_wrapper').hide();
       $(document).find('.seal_optin_head').hide();
       $(document).find('.seal_placement_head').hide();
       $(document).find('.seal_placement_btn').removeClass('seal_placement_active');
       $(document).find(`#itg_properties_data input[name="properties[Signet Seal]"]`).remove();
       cal_price(0);
       return;
     }

     // All other cases — show JSA (if present)
     $(document).find('.jsa_authentication_wrapper').show();

     // Seal is mutually exclusive with JSA — keep hidden if JSA Yes is active
     if (!$(document).find('.signet_seal_wrapper').length) return;
     if ($(document).find('.jsa_yes_btn').hasClass('jsa_toggle_active')) {
       $(document).find('.signet_seal_wrapper').hide();
       return;
     }
     $(document).find('.signet_seal_wrapper').show();
     var showOptIn = isSpiActive && isTcOrComic && !hasCgc;
     if (showOptIn) {
       $(document).find('.seal_optin_head').show();
       $(document).find('.seal_placement_head').hide();
       $(document).find('.seal_placement_btn').removeClass('seal_placement_active');
       $(document).find(`#itg_properties_data input[name="properties[Signet Seal]"]`).remove();
       $(document).find('.seal_no_btn').addClass('seal_toggle_active');
       $(document).find('.seal_yes_btn').removeClass('seal_toggle_active');
     } else {
       $(document).find('.seal_optin_head').hide();
       $(document).find('.seal_placement_head').show();
     }
   }

   $(document).on('click', '.seal_no_btn', function() {
     $(document).find('.seal_no_btn').addClass('seal_toggle_active');
     $(document).find('.seal_yes_btn').removeClass('seal_toggle_active');
     $(document).find('.seal_placement_head').hide();
     $(document).find('.seal_placement_btn').removeClass('seal_placement_active');
     $(document).find(`#itg_properties_data input[name="properties[Signet Seal]"]`).remove();
   });

   $(document).on('click', '.seal_yes_btn', function() {
     $(document).find('.seal_yes_btn').addClass('seal_toggle_active');
     $(document).find('.seal_no_btn').removeClass('seal_toggle_active');
     $(document).find('.seal_placement_head').show();
   });

   $(document).on('click', '.seal_placement_btn', function() {
     $(document).find('.seal_placement_btn').removeClass('seal_placement_active');
     $(this).addClass('seal_placement_active');
     var placement = $(this).attr('data-placement');
     $(document).find(`#itg_properties_data input[name="properties[Signet Seal]"]`).remove();
     $(document).find('#itg_properties_data').append(`<input type="hidden" name="properties[Signet Seal]" value="${placement}">`);
   });

});

$(document).on("click", ".select_ink_color_label", function(event) {
    event.target.classList.add("active-link-color");
});


// Get the element with the class 'select_ink_color_wrapper'
var addcustom = document.querySelector('.item_from_signetstore_wrapper .select_ink_color_wrapper');

if (addcustom) {
  // addcustom.classList.add("link-wrapper-custom");
   addcustom.classList.add("itg-custom-link-wrapper");
}
